// Polish translations
export const pl: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Panel',
  'menu.orderNew': 'Rejestracja Produktu',
  'menu.deliveryList': 'Lista Dostaw',
  'menu.delivery': 'Dostawa',
  'menu.receipt': 'Drukuj Paragon/Etykietę',
  'menu.definitions': 'Definicje',
  'menu.customers': 'Klienci',
  'menu.products': 'Definicje Produktów',
  'menu.pricing': 'Definicje Cen',
  'menu.tailoring': 'Operacje Krawieckie',
  'menu.attributes': 'Atrybuty Produktów',
  'menu.users': 'Użytkownicy',
  'menu.productOrdering': 'Porządkowanie Produktów',
  'menu.discounts': 'Definicje Rabatów',
  'menu.settings': 'Ustawienia',
  'menu.generalSettings': 'Ustawienia Ogólne',
  'menu.permissions': 'Zarządzanie Uprawnieniami',
  'menu.subscription': 'Abonament',
  'menu.invoices': 'Zarządzanie Fakturami',
  'menu.expenses': 'Wpis Wydatków',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Raporty i księgowość',
  'menu.systemAndCommunication': 'System i komunikacja',
  'menu.reportsList': 'Lista Paragonów',
  'menu.accountStatement': 'Wyciąg z Konta',
  'menu.tickets': 'Zgłoszenia Wsparcia',
  'menu.support': 'Wsparcie',
  'menu.profile': 'Profil',
  'menu.logout': 'Wyloguj',
  'menu.notifications': 'Powiadomienia SMS/WhatsApp',
  'menu.whatsappConnection': 'Połączenie WhatsApp',
  'menu.smsConnection': 'Połączenie SMS',
  
  // Dashboard
  'dashboard.title': 'Panel',
  'dashboard.todaySales': 'Sprzedaż Dzisiaj',
  'dashboard.totalOrders': 'Wszystkie Zamówienia',
  'dashboard.pendingDeliveries': 'Dostawy w Toku',
  'dashboard.activeCustomers': 'Aktywni Klienci',
  'dashboard.recentOrders': 'Ostatnie Zamówienia',
  'dashboard.viewAll': 'Zobacz Wszystko',
  'dashboard.quickActions': 'Szybkie Akcje',
  'dashboard.newOrder': 'Nowe Zamówienie',
  'dashboard.newCustomer': 'Nowy Klient',
  'dashboard.deliveries': 'Dostawy',
  'dashboard.reports': 'Raporty',
  'dashboard.today': 'Dzisiaj',
  'dashboard.yesterday': 'Wczoraj',
  'dashboard.week': 'Tydzień',
  'dashboard.month': 'Miesiąc',
  'dashboard.quarter': 'Kwartał',
  'dashboard.year': 'Rok',
  'dashboard.totalRevenue': 'Całkowity Przychód',
  'dashboard.totalOrdersCard': 'Wszystkie Zamówienia',
  'dashboard.totalPieces': 'Wszystkie Sztuki',
  'dashboard.cancelled': 'Anulowane',
  'dashboard.inProcess': 'W Realizacji',
  'dashboard.inProcessDesc': 'Zamówienia w realizacji',
  'dashboard.ready': 'Gotowe',
  'dashboard.readyDesc': 'Zamówienia gotowe do dostawy',
  'dashboard.delivered': 'Dostarczone',
  'dashboard.deliveredDesc': 'Ukończone zamówienia',
  'dashboard.announcements': 'Ogłoszenia',
  'dashboard.announcementAll': 'Ogólne',
  'dashboard.announcementPrivate': 'Prywatne',
  
  // Order Entry
  'order.title': 'Nowe Zamówienie',
  'order.customer': 'Klient',
  'order.selectCustomer': 'Wybierz Klienta',
  'order.newCustomer': 'Nowy Klient',
  'order.products': 'Produkty',
  'order.addProduct': 'Dodaj Produkt',
  'order.selectProduct': 'Wybierz Produkt',
  'order.quantity': 'Ilość',
  'order.price': 'Cena',
  'order.total': 'Razem',
  'order.discount': 'Rabat',
  'order.subtotal': 'Suma Częściowa',
  'order.tax': 'VAT',
  'order.grandTotal': 'Suma Całkowita',
  'order.payment': 'Płatność',
  'order.paymentMethod': 'Metoda Płatności',
  'order.cash': 'Gotówka',
  'order.card': 'Karta Kredytowa',
  'order.credit': 'Na Kredyt',
  'order.amountPaid': 'Zapłacona Kwota',
  'order.remainingBalance': 'Pozostałe Saldo',
  'order.deliveryDate': 'Data Dostawy',
  'order.notes': 'Notatki',
  'order.createOrder': 'Utwórz Zamówienie',
  'order.cancel': 'Anuluj',
  
  // Users
  'users.title': 'Użytkownicy',
  'users.addNew': 'Nowy Użytkownik',
  'users.name': 'Imię i Nazwisko',
  'users.email': 'E-mail',
  'users.role': 'Rola',
  'users.pin': 'PIN',
  'users.permissions': 'Uprawnienia',
  'users.allPermissions': 'Wszystkie Uprawnienia',
  'users.permissionCount': '{count} uprawnień',
  'users.changePin': 'Zmień PIN',
  'users.edit': 'Edytuj',
  'users.delete': 'Usuń',
  'users.newUser': 'Nowy Użytkownik',
  'users.editUser': 'Edytuj Użytkownika',
  'users.editingUser': 'Edycja {name}',
  'users.deleteUserTitle': 'Usuń Użytkownika',
  'users.deletingUser': 'Czy na pewno chcesz usunąć {name}?',
  'users.pinCode': 'Kod PIN (4-6 cyfr)',
  'users.selectRole': 'Wybierz rolę',
  'users.patron': 'Właściciel',
  'users.kasiyer': 'Kasjer',
  'users.sofor': 'Kierowca',
  'users.eleman': 'Pracownik',
  'users.changePinTitle': 'Zmień Kod PIN',
  'users.newPin': 'Nowy Kod PIN',
  'users.confirmPin': 'Potwierdź Kod PIN',
  'users.pinMismatch': 'Kody PIN nie pasują',
  'users.pinRequired': 'Kod PIN wymagany',
  'users.pinLength': 'Kod PIN musi zawierać 4-6 cyfr',
  'users.changingPinFor': 'Zmiana PIN dla {name}',
  
  // Products
  'products.title': 'Definicje Produktów',
  'products.addNew': 'Nowy Produkt',
  'products.category': 'Kategoria',
  'products.name': 'Nazwa Produktu',
  'products.price': 'Cena',
  'products.color': 'Kolor',
  'products.active': 'Aktywny',
  'products.actions': 'Akcje',
  'products.search': 'Szukaj Produktu...',
  'products.noProducts': 'Nie znaleziono produktów',
  'products.noCategoryProducts': 'Brak produktów w tej kategorii',
  'products.emptyCart': 'Koszyk pusty',
  
  // Service Types
  'service.tailor': 'Krawiec',
  'service.dryCleaning': 'Pralnia Chemiczna',
  'service.washing': 'Pranie',
  'service.ironing': 'Prasowanie',
  'service.dyeing': 'Farbowanie',
  'service.shoeShine': 'Czyszczenie Butów',
  'service.carpet': 'Dywan',
  'service.tailoring': 'Przeróbki Krawieckie',
  'service.carpetWashing': 'Pranie Dywanów',
  'service.selectService': 'Wybierz usługę',
  'service.addToCart': 'Dodaj do Koszyka',
  'service.total': 'Razem',
  
  // Common
  'common.yes': 'Tak',
  'common.no': 'Nie',
  'common.cancel': 'Anuluj',
  'common.confirm': 'Potwierdź',
  'common.delete': 'Usuń',
  'common.edit': 'Edytuj',
  'common.save': 'Zapisz',
  'common.search': 'Szukaj',
  'common.loading': 'Ładowanie...',
  'common.noData': 'Brak danych',
  'common.actions': 'Akcje',
  'common.status': 'Status',
  'common.date': 'Data',
  'common.time': 'Czas',
  'common.total': 'Razem',
  'common.filter': 'Filtruj',
  'common.export': 'Eksportuj',
  'common.print': 'Drukuj',
  'common.close': 'Zamknij',
  'common.back': 'Wstecz',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Wyślij',
  'common.reset': 'Zresetuj',
  'common.create': 'Utwórz',
  'common.creating': 'Tworzenie...',
  'common.later': 'Później',
  'common.clear': 'Wyczyść',
  'common.copied': 'Skopiowano!',
  'common.copyError': 'Kopiowanie nie powiodło się',
  'common.autoDetected': 'Wykryto automatycznie',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'System Zarządzania Pralnią Chemiczną',
  'login.tenantId': 'ID Firmy',
  'login.tenantPlaceholder': 'id-firmy (np: acme-clean)',
  'login.tenantIdHelp': 'Wprowadź swój unikalny identyfikator firmy',
  'login.continue': 'Kontynuuj →',
  'login.notMember': 'Jeszcze nie jesteś członkiem?',
  'login.startTrial': 'Rozpocznij Bezpłatny Okres Próbny',
  'login.adminLogin': '🔒 Logowanie Administratora',
  'login.enterPin': 'Wprowadź swój kod PIN',
  'login.changeTenant': 'Zmień Firmę',
  'login.clear': 'Wyczyść',
  'login.delete': 'Usuń',
  'login.login': 'Zaloguj',
  'login.loggingIn': 'Logowanie...',
  'login.defaultPinOwner': 'Domyślny PIN: <strong>1234</strong> (Właściciel)',
  'login.defaultPinCashier': 'Domyślny PIN: <strong>0000</strong> (Kasjer)',
  'login.systemInitializing': 'Inicjalizacja systemu...',
  'login.pinMinLength': 'PIN musi zawierać co najmniej 4 cyfry',
  'login.invalidTenantId': 'Wprowadź prawidłowe ID firmy',
  'login.tenantNotFound': 'Ten kod firmy nie został znaleziony. Sprawdź lub utwórz nowe konto.',
  'login.loginFailed': 'Logowanie nie powiodło się',
  'login.welcome': 'Witaj, {name}',
  'login.tagline': 'Oprogramowanie do pralni chemicznej — Inteligentne i łatwe rozwiązania dla Twojej firmy',

  // Signup translations
  'signup.title': 'Rozpocznij Bezpłatny Okres Próbny',
  'signup.subtitle': '15 dni bezpłatnego okresu próbnego, bez karty kredytowej',
  'signup.backToLogin': 'Powrót do Strony Logowania',
  'signup.companyCode': 'Kod Firmy',
  'signup.companyCodePlaceholder': 'np: cleanpro',
  'signup.companyCodeHelp': 'Ten kod będzie używany do logowania do systemu',
  'signup.companyCodeMinLength': 'Kod firmy musi zawierać co najmniej 3 znaki',
  'signup.companyName': 'Nazwa Firmy',
  'signup.companyNamePlaceholder': 'Nazwa Twojej Firmy',
  'signup.companyNameRequired': 'Nazwa firmy jest wymagana',
  'signup.fullName': 'Imię i Nazwisko',
  'signup.fullNamePlaceholder': 'Twoje Imię i Nazwisko',
  'signup.fullNameRequired': 'Imię i nazwisko jest wymagane',
  'signup.phone': 'Telefon',
  'signup.phonePlaceholder': '+48 123 456 789',
  'signup.validPhoneRequired': 'Wprowadź prawidłowy numer telefonu',
  'signup.email': 'E-mail',
  'signup.emailPlaceholder': 'przyklad@firma.pl',
  'signup.validEmailRequired': 'Wprowadź prawidłowy adres e-mail',
  'signup.createAccount': 'Utwórz Konto',
  'signup.creating': 'Tworzenie...',
  'signup.terms': 'Tworząc konto, akceptujesz Warunki Korzystania i Politykę Prywatności.',
  'signup.success': 'Rejestracja zakończona sukcesem! Twoje dane logowania zostały wysłane na Twój adres e-mail.',
  'signup.successTitle': 'Rejestracja Zakończona Sukcesem!',
  'signup.successMessage': 'Twoje konto zostało pomyślnie utworzone.',
  'signup.emailSent': 'Twoje dane logowania zostały wysłane na Twój adres e-mail.',
  'signup.redirecting': 'Przekierowywanie do strony logowania...',
  'signup.startupPackageLoaded': 'Pakiet Startowy Załadowany!',
  'signup.products': 'Produkty',
  'signup.customers': 'Klienci',
  'signup.users': 'Użytkownicy',
  'signup.demoDataReady': '✨ Twoje dane demonstracyjne są gotowe, możesz zacząć z nich korzystać natychmiast!',
  'signup.loginInfo': '📧 Twoje Dane Logowania',
  'signup.loginInfoSent': '💡 Te informacje zostały również wysłane na Twój adres e-mail',
  'signup.loginNow': 'Zaloguj Się Teraz →',

  'customerStatement.receiptDelivered': 'Dostarczone',
  'customerStatement.receiptOpen': 'Otwarte',
  'customerStatement.selectDateRange': 'Wybierz zakres dat',
  'customerStatement.thisMonth': 'Ten miesiąc',
  'customerStatement.lastMonth': 'Poprzedni miesiąc',
  'customerStatement.allTime': 'Cały czas',
  'customerStatement.startDate': 'Data początkowa',
  'customerStatement.endDate': 'Data końcowa',
  'customerStatement.printPDF': 'Drukuj wyciąg (PDF)',
  'customerStatement.title': 'WYCIĄG Z KONTA',
  'customerStatement.customerName': 'Nazwa klienta',
  'customerStatement.phone': 'Telefon',
  'customerStatement.address': 'Adres',
  'customerStatement.openingBalance': 'Saldo otwarcia',
  'customerStatement.closingBalance': 'Saldo zamknięcia',
  'customerStatement.description': 'Opis',
  'customerStatement.type': 'Typ',
  'customerStatement.debit': 'Debet',
  'customerStatement.credit': 'Kredyt',
  'customerStatement.total': 'ŁĄCZNIE',
  'customerStatement.cancelled': 'ANULOWANE',
  'customerStatement.payment': 'Płatność',
  'customerStatement.items': 'pozycji',
  'customerStatement.noTransactions': 'Brak transakcji w wybranym okresie.',
  'customerStatement.statementDate': 'Data wyciągu',

  'tailoring.title': 'Usługi Krawieckie',
  'tailoring.addNew': 'Nowa Operacja',
  'tailoring.subtitle': 'Tutaj możesz zaktualizować ceny usług krawieckich',
  'tailoring.addNewDescription': 'Dodaj niestandardowy typ operacji krawieckiej',
  'tailoring.add': 'Dodaj',
  'tailoring.savePrices': 'Zapisz ceny',
  'tailoring.default': 'Domyślny',
  'tailoring.infoTitle': 'Informacja',
  'tailoring.info1': 'Po zmianie cen kliknij "Zapisz ceny"',
  'tailoring.info2': 'Przycisk "Nowa Operacja" pozwala dodawać niestandardowe typy operacji',
  'tailoring.info3': 'Niestandardowe operacje można usunąć ikoną kosza',
  'tailoring.info4': 'Ceny te są używane przy tworzeniu zamówień z usługą krawiecką',
  'tailoring.info5': 'Możesz ustawić osobną cenę dla każdej operacji krawieckiej',
  'tailoring.info6': 'Ceny są obliczane automatycznie przy dodawaniu do koszyka',
  'tailoring.loadError': 'Nie można załadować cen',
  'tailoring.nameRequired': 'Proszę podać nazwę operacji',
  'tailoring.invalidPrice': 'Proszę podać prawidłową cenę',
  'tailoring.addSuccess': 'Nowa operacja krawiecka dodana!',
  'tailoring.saveError': 'Błąd zapisu',
  'tailoring.deleteConfirm': 'Czy na pewno chcesz usunąć tę operację?',
  'tailoring.deleteSuccess': 'Operacja usunięta',
  'tailoring.deleteError': 'Błąd usuwania',
  'tailoring.saveSuccess': 'Ceny krawieckie zapisane!',
  'tailoring.addNewTitle': 'Dodaj nową operację krawiecką',
  'tailoring.operationNameLabel': 'Nazwa operacji',
  'tailoring.priceLabel': 'Cena',
  'tailoring.iconLabel': 'Ikona (Emoji)',
  'tailoring.operationNamePlaceholder': 'Np: Szycie kołnierza',
  'tailoring.cancel': 'Anuluj',
  'tailoring.save': 'Zapisz',
  'tailoring.icon': 'Ikona',
  'tailoring.operationName': 'Nazwa operacji',
  'tailoring.price': 'Cena',
  'tailoring.addCustom': 'Dodaj niestandardowy',

  'hardware.title': 'Sklep sprzętowy',
  'hardware.subtitle': 'Drukarki paragonów, etykiet i urządzenia Caller ID',
  'hardware.cart': 'Koszyk',
  'hardware.infoTitle': 'Informacja',
  'hardware.infoText': 'Te produkty sprzętowe są obecnie dostępne do zakupu tylko w Turcji. Są wymienione w celach informacyjnych dla innych krajów.',
  'hardware.myCart': 'Mój koszyk',
  'hardware.cartEmpty': 'Koszyk pusty',
  'hardware.vatSuffix': '+ VAT',
  'hardware.total': 'Łącznie',
  'hardware.checkout': 'Przejdź do płatności',
  'hardware.receiptPrinters': 'Drukarki paragonów',
  'hardware.receiptPrintersSubtitle': 'Drukarki termiczne 80mm z automatycznym obcinakiem',
  'hardware.compatibilityTitle': 'Zgodność z CleandySoft',
  'hardware.receiptCompatText': 'Działa ze wszystkimi drukarkami termicznymi 80mm z automatycznym obcinakiem.',
  'hardware.labelPrinters': 'Drukarki etykiet',
  'hardware.labelPrintersSubtitle': 'Drukarki igłowe, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Przetestowane modele',
  'hardware.labelCompatText': 'Przetestowane dla Epson TM-U220 i Bixolon SRP-270. Inne marki lub modele mogą mieć problemy.',
  'hardware.callerIdTitle': 'Urządzenia Caller ID',
  'hardware.callerIdSubtitle': 'Identyfikacja połączeń od klientów',
  'hardware.compatibilityNote': 'Uwaga dotycząca zgodności',
  'hardware.callerIdCompatText': 'Przetestowane tylko dla modelu CIDShow 2-liniowego. Inne marki lub modele mogą działać, ale nie są gwarantowane.',
  'hardware.barcodeScanners': 'Skanery kodów kreskowych',
  'hardware.barcodeScannerSubtitle': 'Skanery USB kodów kreskowych i QR',
  'hardware.barcodeCompatText': 'Wszystkie skanery 2D mogą działać z CleandySoft. Skanery w trybie USB HID są obsługiwane automatycznie.',
  'hardware.driverDownloads': 'Pobieranie sterowników i oprogramowania',
  'hardware.driverDownloadsText': 'Zaleca się pobranie odpowiedniego sterownika przed podłączeniem drukarki.',
  'hardware.onlyTurkey': 'Ten produkt jest dostępny do zakupu tylko w Turcji',
  'hardware.addedToCart': 'Dodano do koszyka!',
  'hardware.available': 'Dostępny',
  'hardware.info': 'Info',
  'hardware.features': 'Funkcje',
  'hardware.addToCart': 'Dodaj do koszyka',
  'hardware.infoOnly': 'Tylko informacyjnie',
  'expenses.expenseType': 'Typ wydatku',
  'expenses.allBranches': 'Wszystkie oddziały',
  'expenses.noBranch': 'Bez oddziału',
  'expenses.allTypes': 'Wszystkie typy',
  'expenses.categoryBy': 'Według kategorii',
  'expenses.records': 'rekordów',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Nie można utworzyć pliku Excel',
  'expenses.branchSelect': 'Wybierz oddział',
  'expenses.noBranchSelected': '— Brak wybranego oddziału —',
  'expenses.myBranch': 'Mój oddział',
  'expenses.canOnlyDeleteToday': 'Możesz usuwać tylko wydatki wprowadzone dzisiaj.',
  // ---- eksik çeviriler (2026-10-14) ----
  'accountStatement.addPayment': 'Dodaj płatność',
  'accountStatement.allTime': 'Cały okres',
  'accountStatement.balance': 'Saldo',
  'accountStatement.changeCustomer': 'Zmień klienta',
  'accountStatement.credit': 'Ma (uznanie)',
  'accountStatement.currentBalance': 'Aktualne saldo',
  'accountStatement.customer': 'Klient',
  'accountStatement.customerPlaceholder': 'Wybierz klienta...',
  'accountStatement.customerReceipts': 'Paragony klienta',
  'accountStatement.date': 'Data',
  'accountStatement.debit': 'Winien (obciążenie)',
  'accountStatement.description': 'Opis',
  'accountStatement.exportStatement': 'Pobierz wyciąg',
  'accountStatement.exportStatementPDF': 'Pobierz PDF',
  'accountStatement.loadError': 'Nie udało się wczytać konta klienta',
  'accountStatement.noCustomerSelected': 'Wybierz klienta',
  'accountStatement.noCustomersFound': 'Nie znaleziono klientów',
  'accountStatement.noData': 'Nie znaleziono wyciągu z konta',
  'accountStatement.noReceipts': 'Nie znaleziono paragonów',
  'accountStatement.noTransactions': 'Brak operacji dla tego klienta',
  'accountStatement.order': 'Zamówienie',
  'accountStatement.payment': 'Płatność',
  'accountStatement.paymentAmount': 'Kwota płatności',
  'accountStatement.paymentError': 'Nie udało się zapisać płatności',
  'accountStatement.paymentMethod': 'Metoda płatności',
  'accountStatement.paymentNotes': 'Opis (opcjonalnie)',
  'accountStatement.paymentSaved': 'Płatność zapisana',
  'accountStatement.payments': 'Płatności',
  'accountStatement.period': 'Okres',
  'accountStatement.printStatement': 'Drukuj wyciąg',
  'accountStatement.receipts': 'Paragony',
  'accountStatement.recordPayment': 'Zapisz płatność',
  'accountStatement.remaining': 'Pozostało',
  'accountStatement.searchCustomer': 'Szukaj po nazwisku, telefonie lub adresie...',
  'accountStatement.searchHint': 'Wpisz co najmniej 2 znaki, aby wyszukać klienta',
  'accountStatement.selectCustomer': 'Wybierz klienta',
  'accountStatement.selectCustomerFirst': 'Najpierw wybierz klienta',
  'accountStatement.selectedCustomer': 'Wybrany klient',
  'accountStatement.statement': 'Wyciąg',
  'accountStatement.subtitle': 'Rozrachunki należności i zobowiązań według klientów',
  'accountStatement.title': 'Wyciąg z konta',
  'accountStatement.totalDebt': 'Łączne zadłużenie',
  'accountStatement.totalPaid': 'Łącznie zapłacono',
  'accountStatement.totalPayments': 'Suma płatności',
  'accountStatement.transactions': 'Operacje',
  'announcement.trialInfo': 'Do końca okresu próbnego pozostało {days} dni',
  'announcement.welcome': 'Witamy w Cleandy!',
  'areaCalculation.calculatedArea': 'Obliczona powierzchnia:',
  'areaCalculation.carpetCount': '🔢 Liczba dywanów',
  'areaCalculation.carpetCountPlaceholder': 'Ile dywanów?',
  'areaCalculation.continue': 'Dalej',
  'areaCalculation.directInput': '📏 Wpisz m² bezpośrednio',
  'areaCalculation.exampleNumber': 'Np.: 4',
  'areaCalculation.exampleSqM': 'Np.: 12.5',
  'areaCalculation.height': 'Wysokość (m)',
  'areaCalculation.or': 'LUB',
  'areaCalculation.perCarpet': 'Na dywan',
  'areaCalculation.title': 'Obliczanie powierzchni',
  'areaCalculation.total': 'Razem',
  'areaCalculation.totalSqM': '📏 Łącznie m² (dla {count} dywanów)',
  'areaCalculation.width': 'Szerokość (m)',
  'attributes.add': 'Dodaj atrybut',
  'attributes.addColor': 'Dodaj kolor',
  'attributes.addDamage': 'Dodaj rodzaj uszkodzenia',
  'attributes.addError': 'Nie udało się dodać',
  'attributes.addStain': 'Dodaj rodzaj plamy',
  'attributes.color': 'Kolor',
  'attributes.colors': 'Kolory',
  'attributes.damages': 'Rodzaje uszkodzeń',
  'attributes.deleteError': 'Nie udało się usunąć atrybutu',
  'attributes.deleted': 'Atrybut usunięty',
  'attributes.loadError': 'Nie udało się wczytać atrybutów',
  'attributes.name': 'Nazwa atrybutu',
  'attributes.noAttributes': 'Brak zdefiniowanych atrybutów',
  'attributes.save': 'Zapisz',
  'attributes.saveError': 'Nie udało się zapisać atrybutów',
  'attributes.saved': 'Atrybuty zapisane',
  'attributes.stains': 'Rodzaje plam',
  'attributes.title': 'Atrybuty',
  'attributes.updateError': 'Nie udało się zaktualizować',
  'attributes.value': 'Wartość',
  'back': 'Wstecz',
  'cancel': 'Anuluj',
  'changePin': 'Zmień PIN',
  'changingPin': 'Zmienianie...',
  'charts.branchRevenue': 'Obrót według oddziałów',
  'charts.cashCard': 'Gotówka + karta',
  'charts.cashCardAtDel': '💵 Gotówka/karta (przy wydaniu):',
  'charts.cashCardAtReg': '💵 Gotówka/karta (przy przyjęciu):',
  'charts.collectionSummary': 'Podsumowanie wpłat',
  'charts.currentCollections': '📋 Wpłaty na konto klienta:',
  'charts.customer': 'Klient',
  'charts.dailyItems': 'Wykres dziennej liczby sztuk',
  'charts.dailyRevenue': 'Wykres dziennego obrotu',
  'charts.graphicReports': 'Raporty graficzne',
  'charts.itemCount': 'Liczba sztuk',
  'charts.loadError': 'Nie udało się wczytać danych',
  'charts.noData': 'Brak danych w tym okresie',
  'charts.orders': 'Zamówienia',
  'charts.periodSuffix': 'okres',
  'charts.pieces': 'Liczba sztuk',
  'charts.receipts': 'Liczba paragonów',
  'charts.regDelivery': '(Przyjęcie + wydanie)',
  'charts.revenue': 'Obrót',
  'charts.selectPeriod': 'Wybierz inny okres',
  'charts.top10Customers': '10 klientów z największym obrotem',
  'charts.total': 'Razem',
  'charts.totalItems': 'Łącznie sztuk',
  'charts.totalReceipts': 'Łącznie paragonów',
  'charts.totalRevenue': 'Łączny obrót',
  'common.allYears': 'Wszystkie lata',
  'common.cancelled': 'Anulowane',
  'common.exportExcel': 'Pobierz Excel',
  'common.exportToExcel': 'Eksportuj do Excel',
  'common.items': 'Pozycje',
  'common.loadError': 'Nie udało się wczytać',
  'common.none': 'Brak',
  'common.ok': 'OK',
  'common.paid': 'Zapłacono',
  'common.printDate': 'Data wydruku',
  'common.searchError': 'Błąd wyszukiwania',
  'common.searchResults': '(Wyniki wyszukiwania)',
  'common.unit': 'Jednostka',
  'common.year': 'Rok',
  'confirmPin': 'Potwierdź PIN',
  'create': 'Utwórz',
  'currentPin': 'Obecny PIN',
  'customerCard.address': 'ADRES',
  'customerCard.balanceZero': 'Saldo już wynosi zero.',
  'customerCard.creditLabel': 'nadpłata zostanie wyzerowana',
  'customerCard.debtLabel': 'zadłużenie zostanie wyzerowane',
  'customerCard.heading': 'KARTA KLIENTA',
  'customerCard.printButton': 'Drukuj kartę klienta',
  'customerCard.printTitle': 'Karta klienta',
  'customerCard.resetBalance': 'Wyzeruj saldo',
  'customerCard.resetConfirm': 'Saldo zostanie wyzerowane ({label}). Potwierdzić?',
  'customerCard.resetError': 'Nie udało się wyzerować salda',
  'customerCard.resetSuccess': 'Saldo zostało wyzerowane',
  'customerCard.resetting': 'Zerowanie...',
  'customerCard.tel1': 'TEL 1',
  'customerCard.tel2': 'TEL 2',
  'customers.actions': 'Akcje',
  'customers.add': 'Dodaj klienta',
  'customers.addError': 'Nie udało się dodać klienta',
  'customers.addNew': 'Nowy klient',
  'customers.added': 'Klient dodany',
  'customers.address': 'Adres',
  'customers.adres': 'Adres',
  'customers.balance': 'Saldo',
  'customers.cannotDeleteWithOrders': 'Nie można usunąć klienta, który ma zamówienia',
  'customers.delete': 'Usuń',
  'customers.deleteConfirm': 'Czy na pewno chcesz usunąć klienta „{name}”?',
  'customers.deleteError': 'Nie udało się usunąć klienta',
  'customers.deleted': 'Klient usunięty',
  'customers.edit': 'Edytuj',
  'customers.email': 'E-mail',
  'customers.import': 'Importuj klientów',
  'customers.importTitle': 'Importuj klientów',
  'customers.legacyHidden': 'klientów w starym formacie ukrytych',
  'customers.loadError': 'Nie udało się wczytać klientów',
  'customers.name': 'Imię i nazwisko',
  'customers.noCustomers': 'Nie znaleziono klientów',
  'customers.noResults': 'Brak wyników',
  'customers.notFound': 'Nie znaleziono klienta',
  'customers.notes': 'Notatka',
  'customers.phone': 'Telefon',
  'customers.phoneMissing': 'Numer telefonu klienta nie jest zapisany',
  'customers.search': 'Szukaj klientów...',
  'customers.searchPlaceholder': 'Szukaj po nazwisku, telefonie, e-mailu lub adresie... (przykład: jan+5551234567)',
  'customers.showingFirst50': 'Wyświetlono pierwsze 50 wyników',
  'customers.smsEnabled': 'SMS',
  'customers.tableActions': 'Akcje',
  'customers.tableAddress': 'Adres',
  'customers.tableBalance': 'Saldo',
  'customers.tableContact': 'Kontakt',
  'customers.tableCustomer': 'Klient',
  'customers.tableNotifications': 'Powiadomienia',
  'customers.telefon': 'Telefon',
  'customers.telefon2': 'Telefon 2',
  'customers.title': 'Klienci',
  'customers.totalCount': 'Łącznie klientów: {count}',
  'customers.totalOrders': 'Liczba zamówień',
  'customers.totalResults': 'łącznie',
  'customers.totalSpent': 'Łączne wydatki',
  'customers.updateError': 'Nie udało się zaktualizować klienta',
  'customers.updated': 'Klient zaktualizowany',
  'customers.whatsappEnabled': 'WhatsApp',
  'damage.add': 'Dodaj uszkodzenie',
  'damage.burn': 'Przypalenie',
  'damage.button': 'Problem z guzikiem',
  'damage.buttonMissing': 'Brak guzika',
  'damage.color': 'Farbowanie',
  'damage.delik': 'Dziura',
  'damage.description': 'Opis',
  'damage.fade': 'Wyblaknięcie',
  'damage.fray': 'Strzępienie',
  'damage.hole': 'Dziura',
  'damage.lining': 'Podszewka',
  'damage.location': 'Miejsce',
  'damage.multiple': 'Stan uszkodzeń (można wybrać kilka)',
  'damage.noPhoto': 'Brak zdjęcia',
  'damage.none': 'Brak',
  'damage.other': 'Inne uszkodzenie...',
  'damage.pembe': 'Różowa plama',
  'damage.photo': 'Zdjęcie',
  'damage.saveError': 'Nie udało się zapisać raportu uszkodzeń',
  'damage.saved': 'Raport uszkodzeń zapisany',
  'damage.seam': 'Szew',
  'damage.severity': 'Stopień',
  'damage.stain': 'Plama',
  'damage.tear': 'Rozdarcie',
  'damage.title': 'Raport uszkodzeń',
  'damage.type': 'Rodzaj uszkodzenia',
  'damage.worn': 'Przetarcie',
  'damage.zipper': 'Zamek błyskawiczny',
  'dashboard.allTime': 'Cały okres',
  'dashboard.referral.button': 'Zaproś teraz',
  'dashboard.referral.desc': '1 miesiąc gratis, gdy zaproszona firma się zarejestruje!',
  'dashboard.referral.title': 'Zaproś znajomego',
  'delivery.actions': 'Akcje',
  'delivery.complete': 'Wydaj',
  'delivery.customer': 'Klient',
  'delivery.delivered': 'Wydano',
  'delivery.deliveredItems': 'Wydano',
  'delivery.deliveredProducts': 'WYDANE PRODUKTY',
  'delivery.deliveryDate': 'Data wydania',
  'delivery.error': 'Błąd wydania',
  'delivery.items': 'Produkty',
  'delivery.loadError': 'Nie udało się wczytać wydań',
  'delivery.markDelivered': 'Oznacz jako wydane',
  'delivery.markReady': 'Oznacz jako gotowe',
  'delivery.noOrders': 'Nie znaleziono zamówień',
  'delivery.orderDelivered': 'Zamówienie oznaczone jako wydane',
  'delivery.orderNumber': 'Nr zamówienia',
  'delivery.orderReady': 'Zamówienie oznaczone jako gotowe',
  'delivery.pending': 'W realizacji',
  'delivery.printReceipt': 'Drukuj paragon',
  'delivery.ready': 'Gotowe',
  'delivery.searchOrder': 'Szukaj po numerze zamówienia lub nazwisku klienta...',
  'delivery.status': 'Status',
  'delivery.success': 'Wydanie zakończone pomyślnie',
  'delivery.title': 'Zarządzanie wydaniami',
  'delivery.total': 'Razem',
  'delivery.updateError': 'Nie udało się zaktualizować statusu',
  'deliveryList.address': 'Adres',
  'deliveryList.all': 'Wszystkie',
  'deliveryList.amount': 'Kwota',
  'deliveryList.branchUpdated': 'Oddział wydania zaktualizowany',
  'deliveryList.cancelButton': 'Anuluj zamówienie',
  'deliveryList.cancelConfirm': 'Czy na pewno chcesz anulować to zamówienie? Wymagany jest powód anulowania.',
  'deliveryList.cancelError': 'Błąd anulowania',
  'deliveryList.cancelReasonPlaceholder': 'Powód anulowania (wymagany)...',
  'deliveryList.cancelTitle': 'Anuluj paragon',
  'deliveryList.changeBranch': 'Zmień oddział wydania',
  'deliveryList.complete': 'Zakończ',
  'deliveryList.completed': 'Zakończone',
  'deliveryList.date': 'Data',
  'deliveryList.delivered': 'Wydano',
  'deliveryList.deliveryError': 'Błąd oznaczania jako wydane',
  'deliveryList.driver': 'Kierowca',
  'deliveryList.homeDelivery': 'Pod adres',
  'deliveryList.items': 'Pozycje',
  'deliveryList.loadError': 'Nie udało się wczytać zamówień',
  'deliveryList.messageError': 'Nie udało się wysłać wiadomości do klienta',
  'deliveryList.noBranch': 'Nie wybrano oddziału',
  'deliveryList.noBranchAssigned': 'Nie przypisano oddziału',
  'deliveryList.noOrders': 'Brak zamówień do dostawy',
  'deliveryList.noPhone': 'Nie znaleziono telefonu klienta',
  'deliveryList.orderCancelled': 'Zamówienie anulowane',
  'deliveryList.orderDelivered': 'Zamówienie oznaczone jako wydane',
  'deliveryList.pending': 'Oczekujące',
  'deliveryList.phone': 'Telefon',
  'deliveryList.pickup': 'odbiór',
  'deliveryList.pieces': 'Szt.',
  'deliveryList.ready': 'Gotowe',
  'deliveryList.readyButton': 'Gotowe',
  'deliveryList.receiptButton': 'Paragon',
  'deliveryList.search': 'Nr paragonu, nazwisko klienta lub telefon...',
  'deliveryList.selectBranch': 'Wybierz oddział',
  'deliveryList.selectDriver': 'Wybierz kierowcę',
  'deliveryList.smsSent': '📨 Wiadomość SMS wysłana',
  'deliveryList.status': 'Status',
  'deliveryList.statusUpdateError': 'Nie udało się zaktualizować statusu',
  'deliveryList.statusUpdated': 'Zamówienie oznaczone jako gotowe',
  'deliveryList.title': 'Lista dostaw',
  'deliveryList.updateError': 'Nie udało się zaktualizować',
  'deliveryList.waRemind': 'Przypomnij przez WA',
  'deliveryList.whatsappError': 'Nie udało się wysłać wiadomości WhatsApp',
  'deliveryList.whatsappFailed': 'Nie udało się wysłać przez WhatsApp',
  'deliveryList.whatsappSending': '📱 Wysyłanie wiadomości WhatsApp...',
  'deliveryList.whatsappSent': 'Wiadomość WhatsApp wysłana!',
  'deliveryList.whatsappTimeout': 'Przekroczono limit czasu żądania WhatsApp',
  'deliveryPage.amount': 'Kwota',
  'deliveryPage.changeDeliveryType': 'Zmień sposób wydania',
  'deliveryPage.changeToDelivery': 'Dostawa do domu',
  'deliveryPage.changeToDeliverySuccess': 'Sposób wydania zmieniono na „Dostawa do domu”',
  'deliveryPage.changeToPickup': 'Odbiór osobisty',
  'deliveryPage.changeToPickupError': 'Nie udało się zmienić sposobu wydania',
  'deliveryPage.changeToPickupSuccess': 'Sposób wydania zmieniono na „Odbiór osobisty”',
  'deliveryPage.deliverButton': 'Wydaj zaznaczone',
  'deliveryPage.deliveryError': 'Błąd wydania',
  'deliveryPage.deliverySuccess': 'Wydanie zakończone pomyślnie',
  'deliveryPage.itemsList': 'Lista pozycji',
  'deliveryPage.minSearchLength': 'Wpisz co najmniej 2 znaki',
  'deliveryPage.noOrdersFound': 'Nie znaleziono zamówień',
  'deliveryPage.noReadyOrders': 'Brak gotowych zamówień',
  'deliveryPage.ordersLoadError': 'Nie udało się wczytać zamówień',
  'deliveryPage.payment': 'Płatność',
  'deliveryPage.paymentDialogTitle': 'Wybierz metodę płatności',
  'deliveryPage.pieces': 'Sztuki',
  'deliveryPage.quantity': 'Ilość',
  'deliveryPage.receiptDelivered': '✅ *WYDANO*',
  'deliveryPage.search': 'Szukaj',
  'deliveryPage.searchAll': 'Wszystko',
  'deliveryPage.searchBy': 'Szukaj według',
  'deliveryPage.searchEmptySubtitle': 'Zostaną wyświetlone zamówienia gotowe do wydania',
  'deliveryPage.searchEmptyTitle': 'Szukaj po nr paragonu, nazwisku lub telefonie',
  'deliveryPage.searchError': 'Nie udało się wyszukać',
  'deliveryPage.searchName': 'Nazwisko klienta',
  'deliveryPage.searchNamePlaceholder': 'Wpisz nr paragonu lub nazwisko klienta...',
  'deliveryPage.searchPhone': 'Szukaj po telefonie...',
  'deliveryPage.searchPhoneBtn': 'Telefon',
  'deliveryPage.searchPlaceholder': 'Szukaj...',
  'deliveryPage.searchReceipt': 'Nr paragonu',
  'deliveryPage.searchReceiptPlaceholder': 'Szukaj po nr paragonu...',
  'deliveryPage.showItems': 'Pokaż pozycje',
  'deliveryPage.statusCancelled': 'Anulowane',
  'deliveryPage.statusDelivered': 'Wydane',
  'deliveryPage.statusNotReady': 'Zamówienie znalezione, ale nie jest gotowe do wydania',
  'deliveryPage.statusPending': 'Oczekujące',
  'deliveryPage.title': 'Wydanie',
  'deliveryPage.unknownProduct': 'Nieznany produkt',
  'deliveryPage.whatsappSending': '📱 Wysyłanie paragonu przez WhatsApp...',
  'driver.delivery': 'Dostawa',
  'driver.pending': 'W realizacji',
  'driver.pickup': 'Odbiór produktów',
  'driver.ready': 'Gotowe',
  'driver.searchHint': 'Wpisz co najmniej 2 znaki, aby wyszukać',
  'driver.searchPlaceholder': 'Nr paragonu, nazwisko lub telefon...',
  'driver.title': 'Panel kierowcy',
  'driver.todayRevenue': 'Dzisiejszy obrót',
  'driver.totalPieces': 'Łącznie sztuk',
  'error.customerNotCreated': 'Nie udało się utworzyć klienta',
  'error.customerNotDeleted': 'Nie udało się usunąć klienta',
  'error.customerNotFound': 'Nie znaleziono klienta',
  'error.customerNotUpdated': 'Nie udało się zaktualizować klienta',
  'error.customersNotLoaded': 'Nie udało się wczytać klientów',
  'error.databaseError': 'Błąd bazy danych',
  'error.expenseNotCreated': 'Nie udało się utworzyć wydatku',
  'error.expenseNotDeleted': 'Nie udało się usunąć wydatku',
  'error.expensesNotLoaded': 'Nie udało się wczytać wydatków',
  'error.forbidden': 'Nie masz uprawnień do tej operacji',
  'error.invalidRequest': 'Nieprawidłowe żądanie',
  'error.orderNotCreated': 'Nie udało się utworzyć zamówienia',
  'error.orderNotUpdated': 'Nie udało się zaktualizować zamówienia',
  'error.ordersNotLoaded': 'Nie udało się wczytać zamówień',
  'error.paymentFailed': 'Płatność nie powiodła się',
  'error.phoneAlreadyExists': 'Ten numer telefonu jest już zarejestrowany! Użyj innego numeru telefonu.',
  'error.productNotCreated': 'Nie udało się utworzyć produktu',
  'error.productNotUpdated': 'Nie udało się zaktualizować produktu',
  'error.productsNotLoaded': 'Nie udało się wczytać produktów',
  'error.serverError': 'Błąd serwera',
  'error.tenantIdRequired': 'Wymagane dane sesji',
  'error.tenantIdRequiredLogin': 'Wymagane dane sesji. Zaloguj się.',
  'error.unauthorized': 'Brak autoryzacji',
  'error.unknownError': 'Wystąpił nieznany błąd',
  'error.userNotCreated': 'Nie udało się utworzyć użytkownika',
  'error.userNotUpdated': 'Nie udało się zaktualizować użytkownika',
  'error.usersNotLoaded': 'Nie udało się wczytać użytkowników',
  'errorBoundary.forbidden': 'Odmowa dostępu',
  'errorBoundary.forbiddenDetails': 'Nie masz wystarczających uprawnień do wykonania tej operacji.',
  'errorBoundary.goHome': 'Wróć na stronę główną',
  'errorBoundary.pageNotFound': 'Nie znaleziono strony',
  'errorBoundary.pageNotFoundDetails': 'Szukana strona nie istnieje lub została przeniesiona.',
  'errorBoundary.persistentIssue': 'Jeśli problem się powtarza, skontaktuj się z zespołem wsparcia.',
  'errorBoundary.reload': 'Odśwież stronę',
  'errorBoundary.serverError': 'Błąd serwera',
  'errorBoundary.serverErrorDetails': 'Wystąpił błąd po stronie serwera. Spróbuj ponownie później.',
  'errorBoundary.technicalDetails': 'Szczegóły techniczne',
  'errorBoundary.unauthorized': 'Brak autoryzacji',
  'errorBoundary.unauthorizedDetails': 'Nie masz uprawnień do wykonania tej operacji.',
  'errorBoundary.unknownError': 'Nieznany błąd',
  'expenses.activeFilter': 'Aktywny filtr',
  'expenses.addNew': 'Nowy wydatek',
  'expenses.amount': 'Kwota',
  'expenses.amountField': 'Kwota:',
  'expenses.amountLabel': 'Kwota (₺) *',
  'expenses.applyFilter': 'Filtruj',
  'expenses.cancel': 'Anuluj',
  'expenses.category': 'Kategoria',
  'expenses.categoryField': 'Kategoria:',
  'expenses.categoryLabel': 'Kategoria *',
  'expenses.categoryPlaceholder': 'Wybierz kategorię...',
  'expenses.clearFilter': 'Wyczyść',
  'expenses.dateField': 'Data:',
  'expenses.dateFilter': 'Filtr daty',
  'expenses.deleteConfirm': 'Czy na pewno chcesz usunąć ten wydatek?',
  'expenses.deleteError': 'Nie udało się usunąć wydatku',
  'expenses.deletePermission': 'ℹ️ Uprawnienie do usuwania wydatków ma tylko rola właściciela.',
  'expenses.deleteTitle': 'Usuń wydatek',
  'expenses.deleted': 'Wydatek usunięty',
  'expenses.deleting': 'Usuwanie...',
  'expenses.description': 'Opis',
  'expenses.descriptionField': 'Opis:',
  'expenses.descriptionLabel': 'Opis *',
  'expenses.endDate': 'Data końcowa',
  'expenses.filterApplied': 'Zastosowano filtr daty',
  'expenses.filterCleared': 'Filtr wyczyszczony',
  'expenses.loadError': 'Nie udało się wczytać wydatków',
  'expenses.newExpense': 'Nowy wydatek',
  'expenses.noExpenses': 'Brak wydatków zapisanych dzisiaj',
  'expenses.saveError': 'Nie udało się zapisać wydatku',
  'expenses.saved': 'Wydatek zapisany',
  'expenses.selectBothDates': 'Wybierz datę początkową i końcową',
  'expenses.showDateFilter': 'Wybierz zakres dat',
  'expenses.startDate': 'Data początkowa',
  'expenses.title': 'Rejestracja wydatków',
  'expenses.total': 'Suma wydatków',
  'expenses.totalToday': 'Dzisiejsza suma wydatków',
  'expenses.yesDelete': 'Tak, usuń',
  'footer.euServers': 'Twoje dane są bezpiecznie przechowywane na naszych serwerach w Unii Europejskiej (Frankfurt).',
  'footer.gdpr': 'Infrastruktura zgodna z RODO.',
  'form.area': 'Powierzchnia',
  'form.color': 'Kolor',
  'form.damage': 'Uszkodzenie',
  'form.notes': 'Uwagi',
  'form.stain': 'Plama',
  'invoices.downloading': 'Pobieranie...',
  'invoices.subtitle': 'Przeglądaj i pobieraj faktury za subskrypcję',
  'invoices.title': 'Zarządzanie fakturami',
  'loading': 'Wczytywanie...',
  'login': 'Zaloguj',
  'login.credentialsTitle': 'Dane logowania',
  'login.demoAccount': 'Konto demo',
  'login.demoCredentials': 'Nazwa użytkownika: demo, PIN: 1234',
  'login.demoLoaded': 'Utworzono przykładowych użytkowników, produkty, klientów i zamówienia!',
  'login.enterCredentials': 'Wpisz nazwę użytkownika i PIN',
  'login.firstLoginChangePin': 'Pierwsze logowanie – zmień kod PIN',
  'login.forget': 'Zapomnij',
  'login.invalidCredentials': 'Nieprawidłowa nazwa użytkownika lub PIN',
  'login.legalText': 'Tworząc konto, akceptujesz nasz Regulamin i Politykę prywatności',
  'login.pin': 'PIN',
  'login.pinDescription': '4–6 cyfr',
  'login.pinRequired': 'PIN jest wymagany',
  'login.rememberMe': 'Zapamiętaj mnie',
  'login.saveCredentialsNote': 'Zapisz te dane logowania!',
  'login.signIn': 'Zaloguj się',
  'login.signingIn': 'Logowanie...',
  'login.tenantIdNotRemembered': 'Identyfikator firmy nie jest zapamiętany',
  'login.tenantRequired': 'Identyfikator firmy jest wymagany',
  'login.tryForFree': 'Wypróbuj za darmo przez 15 dni, bez karty kredytowej',
  'login.username': 'Nazwa użytkownika',
  'login.usernamePlaceholder': 'właściciel, kasjer...',
  'login.usernameRequired': 'Nazwa użytkownika jest wymagana',
  'login.version': 'Wersja',
  'logout': 'Wyloguj',
  'menu.barber': 'Fryzjer / Barber',
  'menu.carWash': 'Myjnia samochodowa',
  'menu.driverPickup': 'Zamówienia do odbioru',
  'menu.hardware': 'Sprzęt',
  'menu.payment': 'Płatność',
  'menu.referral': 'Zaproś',
  'menu.reportsCharts': 'Raport wykresów',
  'nav.logout': 'Wyloguj',
  'nav.user': 'Użytkownik',
  'newPin': 'Nowy PIN',
  'notifications': 'Powiadomienia',
  'notifications.customMessage': 'Własna wiadomość',
  'notifications.failure': 'Nie udało się wysłać powiadomienia',
  'notifications.message': 'Wiadomość',
  'notifications.preview': 'Podgląd',
  'notifications.schedule': 'Zaplanuj',
  'notifications.scheduleLater': 'Wyślij później',
  'notifications.selectCustomer': 'Wybierz klienta',
  'notifications.selectDateTime': 'Wybierz datę i godzinę',
  'notifications.selectTemplate': 'Wybierz szablon',
  'notifications.send': 'Wyślij',
  'notifications.sendError': 'Nie udało się wysłać',
  'notifications.sendNow': 'Wyślij teraz',
  'notifications.sending': 'Wysyłanie...',
  'notifications.sent': 'Wysłano',
  'notifications.sms': 'SMS',
  'notifications.subtitle': 'Skonfiguruj ustawienia powiadomień SMS i WhatsApp',
  'notifications.success': 'Powiadomienie wysłane pomyślnie',
  'notifications.title': 'Powiadomienia SMS/WhatsApp',
  'notifications.whatsapp': 'WhatsApp',
  'order.addressIcon': '📍 Adres',
  'order.addressRequiredForDelivery': 'Do dostawy pod adres wymagany jest adres',
  'order.amount': 'Kwota',
  'order.balanced': 'Rozliczone',
  'order.debt': 'Dług',
  'order.discountOptional': 'Rabat (opcjonalnie)',
  'order.discountPercent': 'Rabat (%{percent})',
  'order.discountRate': 'Rabat',
  'order.discountSummary': 'Podsumowanie rabatu',
  'order.enterDiscountRate': 'Wpisz stawkę rabatu (0-100):',
  'order.homeDelivery': 'Dostawa do domu',
  'order.homeDeliveryIcon': '🏠 Dostawa pod adres',
  'order.homeDeliveryShort': 'Dostawa pod adres',
  'order.newPrice': 'Nowa cena',
  'order.notesOptional': 'Uwagi (opcjonalnie)',
  'order.notesPlaceholder': 'Dodatkowe informacje, specjalne życzenia...',
  'order.priceAndDiscountEdit': 'Edycja ceny i rabatu',
  'order.processing': 'Przetwarzanie...',
  'order.quickDiscount': 'Przyciski szybkiego rabatu',
  'order.receivable': 'Należność',
  'order.selectPaymentMethod': 'Wybierz metodę płatności',
  'order.totalDebt': 'Łączne zadłużenie',
  'order.totalPayments': 'Suma płatności',
  'order.totalWithQuantity': 'Razem ({count} szt.)',
  'orderCreate.addCustomer': 'Dodaj klienta',
  'orderCreate.addressRequired': 'Adres jest wymagany!',
  'orderCreate.allCategories': 'Wszystkie',
  'orderCreate.balance': 'Saldo',
  'orderCreate.cart': 'Koszyk',
  'orderCreate.change': 'Zmień',
  'orderCreate.clickToSelect': 'Kliknij, aby wybrać',
  'orderCreate.continue': 'Dalej',
  'orderCreate.credit': 'Nadpłata',
  'orderCreate.customer': 'Klient',
  'orderCreate.customerAddress': 'Adres',
  'orderCreate.customerEmail': 'E-mail',
  'orderCreate.customerName': 'Imię i nazwisko',
  'orderCreate.customerPhone': 'Telefon',
  'orderCreate.debt': 'Dług',
  'orderCreate.deliveryDate': 'Data wydania',
  'orderCreate.details': 'Szczegóły',
  'orderCreate.discount': 'Rabat',
  'orderCreate.discountLabel': 'Rabat (%)',
  'orderCreate.grandTotal': 'Suma końcowa',
  'orderCreate.homeDelivery': 'Dostawa do domu',
  'orderCreate.homeDeliveryAddress': 'Adres',
  'orderCreate.itemDetails': 'Szczegóły pozycji',
  'orderCreate.newCustomer': 'Nowy klient',
  'orderCreate.payment': 'Płatność',
  'orderCreate.pickupFromAddress': 'Kierowca odbierze',
  'orderCreate.plannedDelivery': 'Planowane wydanie',
  'orderCreate.save': 'Zapisz',
  'orderCreate.searchCustomer': 'Szukaj po nazwisku, telefonie lub adresie... (przykład: jan+5551234567)',
  'orderCreate.select': 'Wybierz',
  'orderCreate.selectCustomer': 'Wybierz klienta',
  'orderCreate.selectCustomerPlaceholder': 'Wybierz klienta',
  'orderCreate.selectOperation': 'Wybierz usługę (ceny zostaną dodane automatycznie)',
  'orderCreate.selectedOperations': 'Wybrane usługi',
  'orderCreate.serviceType': 'Rodzaj usługi',
  'orderCreate.subtotal': 'Suma częściowa',
  'orderCreate.tailoringOperations': 'Usługi krawieckie',
  'orderCreate.tailoringTitle': 'Usługi krawieckie',
  'orderCreate.totalPieces': 'Łącznie sztuk',
  'payment.account': 'Na konto',
  'payment.addPayment': 'Dodaj płatność',
  'payment.adjustment': 'Korekta salda',
  'payment.amount': 'Kwota płatności',
  'payment.amountToPay': 'Kwota do zapłaty',
  'payment.bank': 'Przelew bankowy',
  'payment.bankTransfer': 'Przelew',
  'payment.card': 'Karta',
  'payment.cash': 'Gotówka',
  'payment.collect': 'Pobierz',
  'payment.complete': 'Zakończ płatność',
  'payment.completed': 'Zakończono',
  'payment.confirm': 'Potwierdź płatność',
  'payment.credit': 'Na kredyt',
  'payment.creditCard': 'Karta',
  'payment.enterAmount': 'Wpisz kwotę płatności',
  'payment.failed': 'Płatność nie powiodła się',
  'payment.free': 'Bezpłatnie',
  'payment.madePayments': 'Dokonane płatności',
  'payment.mealCard': 'Karta posiłkowa',
  'payment.method': 'Metoda płatności',
  'payment.onDelivery': 'Przy wydaniu',
  'payment.paid': 'Zapłacono',
  'payment.partial': 'Płatność częściowa',
  'payment.paymentCare': 'Płatność na konto',
  'payment.paymentsSaved': 'Płatności zapisane',
  'payment.pending': 'Oczekuje',
  'payment.posConfirm': 'Po otrzymaniu potwierdzenia płatności z terminala POS naciśnij przycisk „Potwierdź”.',
  'payment.posInstructions': 'Pobierz płatność od klienta za pomocą terminala POS.',
  'payment.posPayment': 'Płatność kartą (terminal POS)',
  'payment.remaining': 'Pozostało',
  'payment.saveError': 'Nie udało się zapisać płatności',
  'payment.saved': 'Płatność zapisana',
  'payment.selectMethod': 'Wybierz metodę płatności',
  'payment.split': 'Płatność dzielona',
  'payment.splitPayment': 'Płatność dzielona',
  'payment.status': 'Status płatności',
  'payment.success': 'Płatność zakończona pomyślnie',
  'permissions.about': 'Informacje o zarządzaniu uprawnieniami',
  'permissions.activePermissions': 'Aktywne uprawnienia:',
  'permissions.cashier': 'Kasjer',
  'permissions.cashierInfo': '<strong>Kasjer:</strong> rola użytkownika z ograniczonymi uprawnieniami do codziennych operacji.',
  'permissions.cashierRole': 'Użytkownik z ograniczonymi uprawnieniami',
  'permissions.deselectAllCashier': 'Odznacz wszystko (kasjer)',
  'permissions.deselectAllPatron': 'Odznacz wszystko (właściciel)',
  'permissions.infoText1': 'Główna rola administratora z dostępem do wszystkich uprawnień systemu.',
  'permissions.infoText2': 'Rola użytkownika z ograniczonymi uprawnieniami do codziennych operacji.',
  'permissions.infoText3': 'Zmiany zaczną obowiązywać dopiero po zapisaniu.',
  'permissions.infoText4': 'Uprawnienia można dostosować dla każdej roli.',
  'permissions.infoTitle': 'Informacje o zarządzaniu uprawnieniami',
  'permissions.patron': 'Właściciel',
  'permissions.patronInfo': '<strong>Właściciel:</strong> główna rola administratora z dostępem do wszystkich uprawnień systemu.',
  'permissions.patronRole': 'Administrator z pełnymi uprawnieniami',
  'permissions.permissionList': 'Lista uprawnień',
  'permissions.saveError': 'Nie udało się zapisać uprawnień',
  'permissions.saveSuccess': 'Uprawnienia zapisane',
  'permissions.saving': 'Zapisywanie...',
  'permissions.selectAllCashier': 'Zaznacz wszystko (kasjer)',
  'permissions.selectAllPatron': 'Zaznacz wszystko (właściciel)',
  'permissions.subtitle': 'Określ uprawnienia ról właściciela i kasjera',
  'permissions.title': 'Zarządzanie uprawnieniami',
  'pinDigits': '6 cyfr',
  'placeholder.customerAddress': 'np. MOKOTÓW, WARSZAWA',
  'placeholder.customerEmail': 'np. jan@example.com',
  'placeholder.customerName': 'np. JAN KOWALSKI',
  'placeholder.customerNotes': 'np. KLIENT VIP',
  'placeholder.customerPhone': 'np. 555 123 4567',
  'pricing.action': 'Akcja',
  'pricing.amount': 'Kwota',
  'pricing.dryCleaning': 'Czyszczenie chemiczne',
  'pricing.enterPrice': 'Wpisz cenę',
  'pricing.ironing': 'Prasowanie',
  'pricing.dyeing': 'Farbowanie',
  'pricing.loadError': 'Nie udało się wczytać produktów',
  'pricing.noProducts': 'Nie znaleziono produktów',
  'pricing.percent': 'Procent',
  'pricing.pricesSaveError': 'Nie udało się zapisać cen',
  'pricing.pricesSaved': 'Ceny zapisane',
  'pricing.product': 'Produkt',
  'pricing.save': 'Zapisz',
  'pricing.saving': 'Zapisywanie',
  'pricing.search': 'Szukaj produktu...',
  'pricing.shoeShine': 'Czyszczenie obuwia',
  'pricing.tailoring': 'Naprawy krawieckie',
  'pricing.title': 'Definicje cen',
  'pricing.washing': 'Pranie',
  'product.damage': 'Uszkodzenie',
  'product.stain': 'Plama',
  'products.addError': 'Nie udało się dodać produktu',
  'products.allCategories': 'Wszystkie kategorie',
  'products.delete': 'Usuń',
  'products.deleteConfirm': 'Czy na pewno chcesz usunąć ten produkt?',
  'products.deleteError': 'Nie udało się usunąć produktu',
  'products.deleting': 'Usuwanie...',
  'products.editProduct': 'Edytuj produkt',
  'products.loadError': 'Nie udało się wczytać produktów',
  'products.newProduct': 'Nowy produkt',
  'products.pieceCount': 'Liczba sztuk',
  'products.productActive': 'Aktywny',
  'products.productAdded': 'Produkt dodany',
  'products.productCategory': 'Kategoria',
  'products.productDeleted': 'Produkt usunięty',
  'products.productInActive': 'Nieaktywny',
  'products.productName': 'Nazwa produktu',
  'products.productPrice': 'Cena',
  'products.productUpdated': 'Produkt zaktualizowany',
  'products.save': 'Zapisz',
  'products.saveError': 'Nie udało się zapisać',
  'products.saved': 'Zapisano',
  'products.saving': 'Zapisywanie...',
  'products.searchProduct': 'Szukaj produktu...',
  'products.updateError': 'Nie udało się zaktualizować produktu',
  'products.updatePrice': 'Aktualizuj cenę',
  'products.updatePrices': 'Aktualizuj ceny',
  'profile.changePassword': 'Zmień hasło',
  'profile.confirmPassword': 'Potwierdź hasło',
  'profile.currentPassword': 'Obecne hasło',
  'profile.email': 'E-mail',
  'profile.name': 'Imię i nazwisko',
  'profile.newPassword': 'Nowe hasło',
  'profile.passwordChangeError': 'Nie udało się zmienić hasła',
  'profile.passwordChanged': 'Hasło zostało zmienione',
  'profile.passwordMismatch': 'Hasła nie są zgodne',
  'profile.phone': 'Telefon',
  'profile.role': 'Rola',
  'profile.save': 'Zapisz',
  'profile.saveError': 'Nie udało się zapisać profilu',
  'profile.saved': 'Zapisano',
  'profile.saving': 'Zapisywanie...',
  'profile.subscriptionBilling': 'Subskrypcja i rozliczenia',
  'profile.title': 'Profil',
  'receipt.addressLabel': 'Adres',
  'receipt.allYears': 'Wszystkie lata',
  'receipt.andLabel': 'i etykieta',
  'receipt.area': 'Powierzchnia',
  'receipt.back': 'Wstecz',
  'receipt.backButton': 'Wróć',
  'receipt.buyCredits': 'Przejdź do Ustawienia → Połączenie WhatsApp, aby kupić kredyty.',
  'receipt.cancelled': 'ANULOWANO',
  'receipt.cancelledBanner': 'ANULOWANO',
  'receipt.cancelledBy': 'Anulowane przez',
  'receipt.cancelledDate': 'Data anulowania',
  'receipt.cancelledReason': 'Powód anulowania',
  'receipt.card': 'Karta',
  'receipt.cash': 'Gotówka',
  'receipt.change': 'Reszta',
  'receipt.connect': 'Połącz',
  'receipt.connected': 'Połączono',
  'receipt.copyButton': 'Kopiuj',
  'receipt.copySend': 'Wyślij przez WhatsApp',
  'receipt.copyTip': 'Wskazówka: możesz też zaznaczyć tekst i nacisnąć Ctrl+C, aby skopiować',
  'receipt.creditsFinished': 'Skończyły się kredyty WhatsApp!',
  'receipt.customer': 'Klient',
  'receipt.customerInfo': 'Klient',
  'receipt.customerName': 'Nazwisko klienta',
  'receipt.customerReceipt': 'Paragon klienta',
  'receipt.damage': 'Uszkodzenie',
  'receipt.date': 'Data',
  'receipt.deliveryDate': 'Data wydania',
  'receipt.discount': 'Rabat',
  'receipt.discountedTotal': 'Suma po rabacie',
  'receipt.footerNote': 'Miłego dnia!',
  'receipt.freeOfCharge': 'Bezpłatnie',
  'receipt.generalTotal': 'Suma ogólna',
  'receipt.goToWhatsAppPage': 'Czy chcesz przejść do strony połączenia WhatsApp?',
  'receipt.grandTotal': 'Suma końcowa',
  'receipt.homeDelivery': 'Dostawa do domu',
  'receipt.invalid': 'NIEWAŻNY',
  'receipt.items': 'Pozycje',
  'receipt.label': 'Etykieta',
  'receipt.labelConfirmDesc': 'Paragon utworzony. Wysłać etykietę do drukarki etykiet?',
  'receipt.labelConfirmTitle': 'Wydrukować etykietę?',
  'receipt.labelNo': 'Nie',
  'receipt.labelPrinted': 'Etykieta wydrukowana!',
  'receipt.labelPrinting': 'Drukowanie etykiety {current}/{total}...',
  'receipt.labelYes': 'Tak, drukuj',
  'receipt.loadError': 'Nie udało się wczytać danych',
  'receipt.markAsDelivered': 'Oznacz zamówienie jako wydane',
  'receipt.markAsReady': 'Oznacz zamówienie jako gotowe',
  'receipt.markDeliveredError': 'Błąd oznaczania jako wydane',
  'receipt.markReadyError': 'Błąd oznaczania jako gotowe',
  'receipt.messageFailed': 'Nie udało się wysłać wiadomości',
  'receipt.messageSendFailed': 'Nie udało się wysłać wiadomości',
  'receipt.messageSent': 'Wiadomość wysłana!',
  'receipt.new': 'Nowy paragon',
  'receipt.newOrder': 'Nowe zamówienie',
  'receipt.noCollection': 'Bez pobrania płatności',
  'receipt.noReceiptFound': 'Nie znaleziono paragonu',
  'receipt.noResults': 'Brak wyników',
  'receipt.notFound': 'Nie znaleziono paragonu',
  'receipt.notes': 'Uwagi',
  'receipt.onlyProEnterprise': 'Tylko Pro/Enterprise',
  'receipt.openWhatsApp': 'Otwórz w WhatsApp',
  'receipt.orderMarkedDelivered': 'Zamówienie oznaczone jako wydane',
  'receipt.orderMarkedReady': 'Zamówienie oznaczone jako gotowe',
  'receipt.orderNumber': 'Nr zamówienia',
  'receipt.orderReceived': 'Zamówienie przyjęte',
  'receipt.paid': 'Zapłacono',
  'receipt.partialPayment': 'Płatność częściowa',
  'receipt.payment': 'Płatność',
  'receipt.paymentMethod': 'Metoda płatności',
  'receipt.phone': 'Telefon',
  'receipt.phoneNotFound': 'Nie znaleziono numeru telefonu',
  'receipt.piece': 'szt.',
  'receipt.plannedDelivery': 'Planowane wydanie',
  'receipt.preview': 'Podgląd paragonu',
  'receipt.price': 'Cena',
  'receipt.print': 'Drukuj paragon',
  'receipt.printButton': 'Drukuj paragon',
  'receipt.printError': 'Błąd drukowania',
  'receipt.printerConnectError': 'Nie udało się połączyć z drukarką',
  'receipt.product': 'Produkt',
  'receipt.products': 'produkty',
  'receipt.productsInfo': 'Produkty',
  'receipt.quantity': 'Ilość',
  'receipt.receiptInfo': 'Informacje o paragonie',
  'receipt.receiptNumber': 'Nr paragonu',
  'receipt.remaining': 'Pozostało',
  'receipt.remainingCredits': 'Pozostałe kredyty',
  'receipt.reprint': 'Drukuj ponownie',
  'receipt.resultsCount': 'Znaleziono wyników: {count}',
  'receipt.scanQR': 'Przejdź do Ustawienia → Połączenie WhatsApp, aby zeskanować kod QR.',
  'receipt.search': 'Wyszukiwanie i ponowny wydruk paragonów',
  'receipt.searchAll': 'Wszystkie',
  'receipt.searchBy': 'Szukaj według',
  'receipt.searchEmpty': 'Wpisz numer paragonu lub nazwę klienta, aby wyszukać',
  'receipt.searchError': 'Błąd wyszukiwania',
  'receipt.searchName': 'Nazwa klienta',
  'receipt.searchPhone': 'Telefon',
  'receipt.searchPlaceholder': 'Szukaj po nr paragonu, nazwie klienta lub telefonie...',
  'receipt.searchReceipt': 'Szukaj paragonu',
  'receipt.searchReceiptPlaceholder': 'Wpisz numer paragonu...',
  'receipt.searchTitle': 'Wyszukaj i wydrukuj ponownie paragon',
  'receipt.selectAll': 'Zaznacz wszystko',
  'receipt.serviceSummary': 'PODSUMOWANIE USŁUG',
  'receipt.sessionNotFound': 'Nie znaleziono sesji. Zaloguj się ponownie.',
  'receipt.stain': 'Plama',
  'receipt.status': 'Status',
  'receipt.subtotal': 'Suma częściowa',
  'receipt.tax': 'Podatek (VAT)',
  'receipt.taxPercent': 'Podatek (20%)',
  'receipt.thankYou': 'Dziękujemy za skorzystanie z naszych usług!',
  'receipt.thermalPrinter': 'Drukarka termiczna',
  'receipt.thisReceiptCancelled': 'TEN PARAGON ZOSTAŁ ANULOWANY',
  'receipt.time': 'Godzina',
  'receipt.title': 'Paragon',
  'receipt.total': 'Razem',
  'receipt.totalPieces': 'Łączna liczba sztuk',
  'receipt.unknownError': 'Nieznany błąd',
  'receipt.whatsappFeature': 'Funkcja WhatsApp jest dostępna w planach Professional i Enterprise',
  'receipt.whatsappNotConnected': 'WhatsApp nie jest połączony!',
  'receipt.whatsappOpening': 'Otwieranie WhatsApp...',
  'receipt.whatsappPreview': 'Podgląd wiadomości WhatsApp',
  'receipt.whatsappPreviewDesc': 'Ta wiadomość zostanie wysłana przez WhatsApp',
  'receipt.whatsappPreviewTitle': 'Podgląd wiadomości WhatsApp',
  'receipt.whatsappSend': 'Wyślij WhatsApp',
  'receipt.year': 'Rok',
  'reports.averageOrder': 'Średnie zamówienie',
  'reports.dateRange': 'Zakres dat',
  'reports.ordersCount': 'Liczba zamówień',
  'reports.salesReport': 'Raport sprzedaży',
  'reports.totalSales': 'Sprzedaż łączna',
  'reportsList.activeOnly': 'Tylko aktywne zamówienia',
  'reportsList.activeReceipt': 'Aktywne paragony',
  'reportsList.amount': 'Kwota',
  'reportsList.cancelReason': 'Powód anulowania:',
  'reportsList.cancelled': 'Anulowano',
  'reportsList.categoryBreakdown': 'Podział według kategorii',
  'reportsList.changeDateRange': 'Wybierz inny zakres dat',
  'reportsList.created': 'Utworzono',
  'reportsList.customer': 'Klient',
  'reportsList.date': 'Data',
  'reportsList.dateError': 'Data początkowa nie może być późniejsza niż data końcowa',
  'reportsList.delivered': 'Wydano',
  'reportsList.deliveredThisPeriod': '📦 Przyjęte wcześniej, wydane w tym okresie ({count} paragonów)',
  'reportsList.description': 'Wyświetlane są wszystkie paragony przyjęte lub wydane w tym zakresie dat',
  'reportsList.empty': 'Nie znaleziono paragonów w tym zakresie dat',
  'reportsList.endDate': 'Data końcowa',
  'reportsList.excelDownloaded': 'Plik Excel został pobrany',
  'reportsList.excelError': 'Nie udało się utworzyć pliku Excel',
  'reportsList.loadError': 'Nie udało się wczytać listy paragonów',
  'reportsList.loading': 'Wczytywanie...',
  'reportsList.noOrders': 'Nie znaleziono zamówień',
  'reportsList.payment': 'Płatność',
  'reportsList.phone': 'Telefon',
  'reportsList.receiptNumber': 'Nr paragonu',
  'reportsList.registered': 'Przyjęte',
  'reportsList.registeredThisPeriod': '📝 Przyjęte w tym okresie ({count} paragonów)',
  'reportsList.reprint': 'Drukuj ponownie',
  'reportsList.search': 'Szukaj',
  'reportsList.searchPlaceholder': 'Nr paragonu, nazwa klienta lub telefon...',
  'reportsList.startDate': 'Data początkowa',
  'reportsList.status': 'Status',
  'reportsList.title': 'Raport listy paragonów',
  'reportsList.totalReceipt': 'Łącznie paragonów',
  'reportsList.totalReceipts': 'Łącznie paragonów',
  'reportsList.totalRevenueExclCancelled': 'Przychód łączny (bez anulowanych)',
  'reportsList.unknown': 'Nieznany',
  'save': 'Zapisz',
  'service.barber': 'Fryzjer / Barber',
  'service.carWash': 'Myjnia i detailing',
  'service.carpetShort': 'Dywan',
  'service.dryCleaningFull': 'Pranie chemiczne',
  'service.dryCleaningShort': 'PCH',
  'service.ironingShort': 'Pras.',
  'service.dyeingShort': 'Farb.',
  'service.shoeShineShort': 'Pucow.',
  'service.sofaWashing': 'Pranie kanap',
  'service.tailoringShort': 'Kraw.',
  'service.washingShort': 'Pranie',
  'settings.addDemoProducts': 'Dodaj produkty demonstracyjne',
  'settings.adding': 'Dodawanie...',
  'settings.address': 'Adres',
  'settings.addressPlaceholder': 'Wpisz adres',
  'settings.africa': 'Afryka',
  'settings.afrika': 'Afryka',
  'settings.americas': 'Ameryka',
  'settings.areYouSure': 'Czy na pewno?',
  'settings.asia': 'Azja',
  'settings.asiaPacific': 'Azja i Pacyfik',
  'settings.asianLanguages': 'Języki azjatyckie',
  'settings.autoConnect': 'Łącz automatycznie przy uruchomieniu',
  'settings.browserNotSupported': 'Przeglądarka nieobsługiwana',
  'settings.callerId': 'Identyfikacja dzwoniącego (Caller ID)',
  'settings.clickConnectButton': 'Kliknij przycisk "Połącz"',
  'settings.company': 'Firma',
  'settings.companyInfo': 'Dane firmy',
  'settings.companyLogo': 'Logo firmy',
  'settings.companyName': 'Nazwa firmy',
  'settings.companyNamePlaceholder': 'Wpisz nazwę firmy',
  'settings.connect': 'Połącz',
  'settings.connectDeviceInfo': 'Podłącz urządzenie USB Caller ID do komputera',
  'settings.connected': 'Połączono',
  'settings.currency': 'Waluta',
  'settings.currencyFormat': 'Format waluty',
  'settings.currencyPosition': 'Położenie symbolu waluty',
  'settings.currencyPositionLeft': 'Po lewej (₺100)',
  'settings.currencyPositionPreview': 'Symbol {position}: {example}',
  'settings.currencyPositionPreviewLeft': 'Symbol po lewej',
  'settings.currencyPositionPreviewRight': 'Symbol po prawej',
  'settings.currencyPositionRight': 'Po prawej (100₺)',
  'settings.cut': 'Obetnij',
  'settings.dangerZone': 'Strefa zagrożenia',
  'settings.dateFormat': 'Format daty',
  'settings.defaultCategory': 'Domyślna kategoria',
  'settings.defaultCategoryDesc': 'Kategoria wybierana automatycznie po otwarciu ekranu przyjmowania produktów',
  'settings.defaultServiceType': 'Domyślny rodzaj usługi',
  'settings.defaultServiceTypeDesc': 'Rodzaj usługi wybierany automatycznie po otwarciu ekranu przyjmowania produktów',
  'settings.delete': 'Usuń',
  'settings.deleteButton': 'Usuń dane demonstracyjne',
  'settings.deleteDemoData': 'Usuń dane demonstracyjne',
  'settings.deleteDemoDataConfirm': 'Tej operacji nie można cofnąć! Przykładowi klienci oraz ich paragony i płatności zostaną usunięci; Twoi własni klienci i paragony zostaną zachowani.',
  'settings.deleteDemoDataDesc': 'Ta operacja trwale usunie wszystkich klientów demonstracyjnych, zamówienia i zapisy płatności.',
  'settings.deleteDemoDataTitle': 'Usuń dane demonstracyjne',
  'settings.deleteDemoDataWarning': 'Usuwa przykładowych klientów dodanych automatycznie podczas konfiguracji wraz z ich paragonami i płatnościami. Klienci i paragony dodane przez Ciebie nie zostaną usunięci.',
  'settings.deleting': 'Usuwanie...',
  'settings.deliveryDays': 'Czas realizacji (dni)',
  'settings.demoProducts': 'Produkty demonstracyjne',
  'settings.demoProductsDescription': 'Dodaje produkty demonstracyjne wraz z ustalonymi cenami',
  'settings.disconnect': 'Rozłącz',
  'settings.email': 'E-mail',
  'settings.europe': 'Europa',
  'settings.europeanLanguages': 'Języki europejskie',
  'settings.expenses': 'Wydatki',
  'settings.facebook': 'Facebook',
  'settings.feedForward': 'Przesuń papier',
  'settings.footerPlaceholder': 'Wiadomość w stopce',
  'settings.footerText': 'Tekst stopki',
  'settings.footerTextHelp': 'Krótka wiadomość wyświetlana na dole paragonu',
  'settings.footerTextPlaceholder': 'Wpisz tekst stopki',
  'settings.formerSovietTurkic': 'Kraje byłego ZSRR i tureckojęzyczne',
  'settings.general': 'Ogólne',
  'settings.genericEscPos': 'Uniwersalna ESC/POS',
  'settings.headerInfo': 'Informacje w nagłówku',
  'settings.headerInfoPlaceholder': 'np.: Pralnia chemiczna i prasowanie',
  'settings.howToConnect': '💡 Jak połączyć?',
  'settings.instagram': 'Instagram',
  'settings.integrations': 'Integracje',
  'settings.invoices': 'Faktury',
  'settings.labelPrinter': 'Drukarka etykiet',
  'settings.language': 'Język',
  'settings.languageRegion': 'Język i region',
  'settings.lastCall': 'Ostatnie połączenie',
  'settings.loadSchema': 'Wczytaj schemat',
  'settings.loadSchemaConfirm': 'Spowoduje to utworzenie schematu bazy danych. Kontynuować?',
  'settings.loadSchemaTitle': 'Wczytaj schemat bazy danych',
  'settings.loading': 'Wczytywanie...',
  'settings.logo': 'Logo',
  'settings.logoDescription': 'Logo będzie widoczne na paragonach i w lewym górnym rogu programu. Zalecany rozmiar: co najmniej 300x120 px, PNG lub JPG w wysokiej rozdzielczości',
  'settings.majorCurrencies': 'Główne waluty',
  'settings.menu': 'Menu ustawień',
  'settings.middleEast': 'Bliski Wschód',
  'settings.middleEastAfricanLanguages': 'Języki Bliskiego Wschodu i Afryki',
  'settings.middleEastGulf': 'Bliski Wschód i Zatoka Perska',
  'settings.noLogo': 'Brak logo',
  'settings.notConnected': 'Nie połączono',
  'settings.notifications': 'Powiadomienia',
  'settings.numberFormat': 'Format liczb',
  'settings.numberFormatCommaDot': 'Przecinek dziesiętny (1,234.56)',
  'settings.numberFormatDotComma': 'Kropka dziesiętna (1.234,56)',
  'settings.numberFormatSpaceComma': 'Spacja jako separator (1 234,56)',
  'settings.oceania': 'Oceania',
  'settings.openDrawer': 'Otwórz szufladę',
  'settings.orderCreated': 'Zamówienie utworzone',
  'settings.orderDelivered': 'Zamówienie wydane',
  'settings.orderReady': 'Zamówienie gotowe',
  'settings.otherLanguages': 'Inne języki',
  'settings.paperWidth': 'Szerokość papieru',
  'settings.phone': 'Telefon',
  'settings.phonePlaceholder': 'np.: 0212 123 45 67',
  'settings.popularLanguages': 'Popularne języki',
  'settings.previewItem1': 'Produkt 1',
  'settings.previewItem2': 'Produkt 2',
  'settings.previewTotal': 'RAZEM',
  'settings.printer': 'Drukarka',
  'settings.printerConnect': 'Połącz',
  'settings.printerConnected': 'Połączono',
  'settings.printerConnection': 'Połączenie z drukarką',
  'settings.printerDisconnect': 'Rozłącz',
  'settings.printerModel': 'Model drukarki',
  'settings.printerNotConnected': 'Nie połączono',
  'settings.printerSettings': 'Ustawienia drukarki',
  'settings.productsWillBeKept': 'Produkty zostaną zachowane',
  'settings.receiptFooterText': 'Tekst stopki paragonu',
  'settings.receiptNote': 'Uwaga na paragonie',
  'settings.receiptNoteHelp': 'Szczegółowe warunki i zasady',
  'settings.receiptNotePlaceholder': 'Wpisz uwagę na paragonie',
  'settings.receiptPreview': 'Podgląd paragonu',
  'settings.receiptSettings': 'Ustawienia paragonu',
  'settings.receiptVisibleOnReceipt': 'Widoczne na paragonie',
  'settings.removeLogo': 'Usuń logo',
  'settings.reports': 'Raporty',
  'settings.reverse': 'Cofnij papier',
  'settings.reverseTest': '--- Test zwrotu płatności ---',
  'settings.save': 'Zapisz',
  'settings.saveError': 'Nie udało się zapisać ustawień',
  'settings.saved': 'Ustawienia zapisane!',
  'settings.selectDevice': 'Wybierz z listy urządzenie CID (zwykle "USB Serial Device")',
  'settings.showDecimals': 'Pokaż miejsca dziesiętne',
  'settings.showDecimalsDesc': 'Wyświetlaj kwoty z 2 miejscami po przecinku',
  'settings.showTax': 'Pokaż podatek',
  'settings.smsTemplates': 'Szablony wiadomości SMS',
  'settings.socialMedia': 'Media społecznościowe',
  'settings.successful': 'zakończono pomyślnie!',
  'settings.taxRate': 'Stawka podatku',
  'settings.testPrint': 'Wydruk testowy',
  'settings.testPrintHeader': '=== TEST DRUKARKI ===',
  'settings.testPrinted': 'Wydruk testowy wykonany!',
  'settings.tickets': 'Zgłoszenia do pomocy technicznej',
  'settings.timezone': 'Strefa czasowa',
  'settings.title': 'Ustawienia',
  'settings.turkey': 'Turcja',
  'settings.uploadLogo': 'Prześlij logo',
  'settings.webSerialNotSupported': 'Twoja przeglądarka nie obsługuje Web Serial API. Zalecamy przeglądarki oparte na Chromium (Chrome, Edge, Brave).',
  'settings.webSerialSupported': 'Web Serial API obsługiwane',
  'settings.website': 'Strona internetowa',
  'settings.whatsappTemplates': 'Szablony wiadomości WhatsApp',
  'settings.workOnSunday': 'Praca w niedziele',
  'settings.yesDelete': 'Tak, usuń',
  'settings.zReport': 'Raport Z',
  'signup.bt.barber.desc': 'Fryzjer, barber i salon kosmetyczny',
  'signup.bt.carWash.desc': 'Mycie, woskowanie, polerowanie i detailing aut',
  'signup.bt.carpetWashing.desc': 'Czyszczenie dywanów, kilimów i chodników',
  'signup.bt.dryCleaning.desc': 'Czyszczenie odzieży, zasłon i tekstyliów',
  'signup.bt.shoeShine.desc': 'Czyszczenie i pielęgnacja obuwia',
  'signup.bt.sofaWashing.desc': 'Pranie sof, kanap i foteli',
  'signup.bt.tailoring.desc': 'Usługi krawieckie, przeróbki i szycie',
  'signup.businessType.continue': 'Dalej',
  'signup.businessType.hint': 'Domyślny ekran zostanie ustawiony automatycznie na podstawie Twojego wyboru',
  'signup.businessType.question': 'Jaki rodzaj działalności prowadzisz?',
  'signup.companyDetails': 'Dane firmy',
  'signup.errors.companyCodeRequired': 'Kod firmy jest wymagany',
  'signup.errors.companyCodeTooShort': 'Kod firmy musi mieć co najmniej 3 znaki',
  'signup.errors.companyNameRequired': 'Nazwa firmy jest wymagana',
  'signup.errors.emailInvalid': 'Wprowadź prawidłowy adres e-mail',
  'signup.errors.emailRequired': 'Adres e-mail jest wymagany',
  'signup.errors.ownerNameRequired': 'Imię i nazwisko są wymagane',
  'signup.errors.signupFailed': 'Rejestracja nie powiodła się',
  'signup.fields.companyCode': 'Kod firmy',
  'signup.fields.companyName': 'Nazwa firmy',
  'signup.fields.country': 'Kraj',
  'signup.fields.email': 'Adres e-mail',
  'signup.fields.ownerName': 'Imię i nazwisko',
  'signup.fields.phone': 'Numer telefonu',
  'signup.freeTrial': '🎁 15 dni bezpłatnego okresu próbnego w cenie!',
  'signup.haveAccount': 'Masz już konto? Zaloguj się',
  'signup.hints.companyCode': 'Ten kod będzie używany do logowania. Może zawierać tylko litery i cyfry.',
  'signup.hints.country': 'Ustawienia waluty i języka zostaną skonfigurowane automatycznie na podstawie Twojego kraju.',
  'signup.placeholders.companyCode': 'np.: cleanpro',
  'signup.placeholders.companyName': 'np.: CleanPro Pralnia Chemiczna',
  'signup.placeholders.email': 'np.: jan@cleanpro.com',
  'signup.placeholders.ownerName': 'np.: Jan Kowalski',
  'signup.placeholders.phone': 'np.: +48 123 456 789',
  'signup.referral.bonus': 'Bonus polecający',
  'signup.referral.title': 'Kod zaproszenia',
  'smsSettingsRequired': 'Przed wysłaniem testowego SMS-a skonfiguruj i zapisz powyższe ustawienia SMS',
  'stain.blood': 'Krew',
  'stain.fruit': 'Owoce',
  'stain.ink': 'Atrament',
  'stain.mud': 'Błoto',
  'stain.multiple': 'Stan plam (można wybrać kilka)',
  'stain.none': 'Brak',
  'stain.oil': 'Olej',
  'stain.other': 'Inna plama...',
  'stain.paint': 'Farba',
  'stain.pembe': 'Różowa',
  'stain.rust': 'Rdza',
  'stain.salt': 'Sól',
  'stain.status': 'Stan plam',
  'stain.teaCoffee': 'Herbata/Kawa',
  'status.cancelled': 'Anulowano',
  'status.delivered': 'Wydano',
  'status.pending': 'W realizacji',
  'status.pickup_in_progress': 'Odbiór w toku',
  'status.pickup_pending': 'Do odbioru',
  'status.ready': 'Gotowe',
  'status.received': 'Przyjęto',
  'subscription.accountManagement': 'Zarządzanie kontami klientów',
  'subscription.active': 'Aktywna',
  'subscription.address': 'Adres',
  'subscription.addressPlaceholder': 'Wpisz adres do faktury',
  'subscription.advancedReports': 'Zaawansowane raporty',
  'subscription.applyCoupon': 'Zastosuj',
  'subscription.autoRenewActive': '✅ Automatyczne odnawianie aktywne - Następna płatność:',
  'subscription.autoRenewBadge': '🔄 Subskrypcja odnawiana automatycznie',
  'subscription.autoRenewInfo': '🔄 Twoja subskrypcja odnawia się automatycznie. Przed odnowieniem otrzymasz powiadomienie e-mailem.',
  'subscription.bankTransfer': 'Przelew bankowy',
  'subscription.basicReports': 'Podstawowe raporty',
  'subscription.billingAutoSave': '💾 Twoje dane są zapisywane automatycznie i zostaną uzupełnione przy następnej płatności',
  'subscription.billingCycle': 'Cykl rozliczeniowy',
  'subscription.billingDesc': 'Wprowadź dane do faktury i przejdź do płatności',
  'subscription.billingInfo': 'Dane do faktury',
  'subscription.billingInfoSaved': '✅ Dane do faktury zapisane',
  'subscription.billingLangLabel': 'Język faktury',
  'subscription.billingPeriod': 'Okres rozliczeniowy',
  'subscription.branchCashManagement': 'Zarządzanie kasą dla każdego oddziału',
  'subscription.branchesIncluded': 'Do 2 oddziałów w cenie',
  'subscription.buyNow': 'Kup teraz',
  'subscription.cancel': 'Anuluj subskrypcję',
  'subscription.cancelAnytime': 'ℹ️ Subskrypcję możesz anulować w dowolnym momencie.',
  'subscription.cancelConfirm': 'Czy na pewno chcesz anulować subskrypcję? Usługa będzie działać do końca bieżącego okresu.',
  'subscription.cancelFailed': 'Anulowanie nie powiodło się',
  'subscription.cancelSubBtn': '❌ Anuluj subskrypcję',
  'subscription.cancelSuccess': '✅ Subskrypcja anulowana. Usługa będzie działać do końca bieżącego okresu.',
  'subscription.cardAtPayment': '💳 Płatność zostanie zrealizowana na stronie płatności przy użyciu danych Twojej karty.',
  'subscription.cardInfoTitle': 'Dane karty zostaną podane na stronie płatności',
  'subscription.cardNumber': 'Numer karty',
  'subscription.cardNumberPlaceholder': 'Wpisz numer karty',
  'subscription.changePlan': '💳 Zmień',
  'subscription.changePlanIntl': '🏓 Zmień',
  'subscription.choosePlan': 'Wybierz plan',
  'subscription.companyName': 'Nazwa firmy',
  'subscription.companyNamePlaceholder': 'Wpisz pełną nazwę firmy',
  'subscription.comparePlans': 'Porównaj plany',
  'subscription.completePayment': 'Dokończ płatność',
  'subscription.contactSales': 'Skontaktuj się z działem sprzedaży',
  'subscription.contactSupport': 'Skontaktuj się z pomocą techniczną',
  'subscription.corporateInvoice': 'Faktura dla firmy',
  'subscription.couponCode': 'Kod kuponu',
  'subscription.couponRemoved': 'Kupon usunięty',
  'subscription.couponVerificationFailed': 'Nie udało się zweryfikować kuponu',
  'subscription.creditCard': 'Karta kredytowa',
  'subscription.crossBranchDelivery': 'Wydawanie między oddziałami',
  'subscription.currentPlan': 'Bieżący plan',
  'subscription.currentUsage': 'Bieżące wykorzystanie',
  'subscription.customReports': 'Raporty niestandardowe',
  'subscription.customersLabel': 'Klienci',
  'subscription.cvc': 'CVC',
  'subscription.daysLeft': 'dni pozostało',
  'subscription.discount': 'Rabat',
  'subscription.downgrade': 'Obniż plan',
  'subscription.downgradePlan': 'Obniż',
  'subscription.driverApp': 'Mobilna aplikacja dla kierowcy',
  'subscription.emailNotifBadge': '💳 Powiadomienie e-mail przed odnowieniem',
  'subscription.endDate': 'Data zakończenia',
  'subscription.enterBillingInfo': '📄 Uzupełnij dane do faktury',
  'subscription.enterCompanyName': 'Wpisz nazwę firmy',
  'subscription.enterPhone': 'Wpisz numer telefonu',
  'subscription.enterTaxNumber': 'Wpisz numer NIP',
  'subscription.enterprise': 'Enterprise',
  'subscription.enterpriseDesc': 'Rozwiązania dla firm',
  'subscription.enterpriseOnlyDesc': 'Zarządzanie oddziałami jest dostępne tylko w planie Enterprise. Przejdź na Enterprise, aby zarządzać wieloma oddziałami, osobną kasą dla każdego oddziału i wydawaniem między oddziałami.',
  'subscription.enterpriseOnlyTitle': 'Wymagany plan Enterprise',
  'subscription.expired': 'Wygasła',
  'subscription.expiredOn': 'Wygasła dnia',
  'subscription.expiresOn': 'Wygasa dnia',
  'subscription.expiringDays': 'Twoja subskrypcja wygaśnie za {days} dni. Odnów ją, aby usługa działała bez przerwy.',
  'subscription.expiryDate': 'Data ważności',
  'subscription.expiryLabel': 'Ważna do:',
  'subscription.extendBtn': 'Przedłuż subskrypcję',
  'subscription.extendSubBtn': '💳 Przedłuż subskrypcję',
  'subscription.extendedBy1m': 'Zostanie przedłużona o 1 miesiąc',
  'subscription.extendedBy1y': 'Zostanie przedłużona o 1 rok',
  'subscription.failedPaymentCards': '❌ KARTY TESTOWE – PŁATNOŚĆ NIEUDANA:',
  'subscription.faq1a': 'Po zmianie planu od razu zyskujesz dostęp do nowych funkcji. Wykupiony okres (miesięczny lub roczny) zostaje doliczony do bieżącego okresu subskrypcji.',
  'subscription.faq1q': 'Co się dzieje przy zmianie planu?',
  'subscription.faq2a': 'Jeśli anulujesz subskrypcję, usługa będzie działać do końca bieżącego okresu. Twoje dane są przechowywane przez 15 dni.',
  'subscription.faq2q': 'Co się stanie, jeśli anuluję?',
  'subscription.faq3a': 'Akceptujemy wyłącznie płatności kartą kredytową i debetową. Płatność przelewem nie jest możliwa.',
  'subscription.faq3q': 'Jakie metody płatności akceptujecie?',
  'subscription.faq4a': 'Przez 15 dni od założenia konta możesz bezpłatnie korzystać ze wszystkich funkcji. Po zakończeniu okresu próbnego konieczny jest zakup subskrypcji.',
  'subscription.faq4q': 'Jak działa 15-dniowy okres próbny?',
  'subscription.faqTitle': 'Najczęściej zadawane pytania',
  'subscription.features': 'Funkcje',
  'subscription.featuresIncluded': 'Funkcje:',
  'subscription.freeTrial': '{months} mies. za darmo',
  'subscription.individualInvoice': 'Faktura dla osoby prywatnej',
  'subscription.invalidCard': '📌 Nieprawidłowa karta:',
  'subscription.invalidCoupon': 'Nieprawidłowy kod kuponu',
  'subscription.liveMode': ' LIVE (środowisko produkcyjne)',
  'subscription.loading': 'Wczytywanie subskrypcji...',
  'subscription.manageBilling': 'Zarządzanie fakturami',
  'subscription.managerApp': 'Mobilny panel właściciela',
  'subscription.maxReceipts': 'Maksymalnie {count} paragonów/mies.',
  'subscription.maxUsers': '{count} kont użytkowników',
  'subscription.month': 'mies.',
  'subscription.monthly': 'Miesięcznie',
  'subscription.monthlyLimit': 'Limit miesięczny',
  'subscription.mostPopular': 'Najpopularniejszy',
  'subscription.noSubscription': 'Brak aktywnej subskrypcji',
  'subscription.odealPOS': 'Integracja z terminalem Ödeal POS (opcjonalnie)',
  'subscription.paddleActive': 'Aktywny',
  'subscription.paddleApiNotConfigured': 'Klucz API Paddle nie jest skonfigurowany. Skontaktuj się z administratorem.',
  'subscription.paddleConfigurationMissing': '⚠️ Brak konfiguracji Paddle!',
  'subscription.paddleConfigured': '✅ Tak',
  'subscription.paddleDashboardRequired': '⚠️ Wymagana konfiguracja w panelu Paddle!',
  'subscription.paddleNotConfigured': '❌ Nie',
  'subscription.paddleNotLoaded': 'Paddle SDK nie zostało jeszcze wczytane. Odśwież stronę.',
  'subscription.paddleTestCards': 'Karty testowe zostały wypisane w konsoli! (F12)',
  'subscription.payNow': 'Zapłać teraz',
  'subscription.paymentCancelled': '❌ Płatność anulowana.',
  'subscription.paymentCompleted': '🎉 Płatność zakończona pomyślnie!',
  'subscription.paymentCreationFailed': 'Nie udało się utworzyć płatności. Sprawdź logi konsoli.',
  'subscription.paymentError': 'Błąd płatności: ',
  'subscription.paymentMethod': 'Metoda płatności',
  'subscription.paymentRequiredBadge': '💳 Odnowienie wymaga płatności',
  'subscription.paymentSuccess': '✅ Płatność udana! Twoja subskrypcja została aktywowana.',
  'subscription.paymentTitle': 'Dokończ płatność',
  'subscription.perMonth': 'miesięcznie',
  'subscription.perYear': 'rocznie',
  'subscription.phone': 'Telefon',
  'subscription.phonePlaceholder': 'Wpisz numer telefonu',
  'subscription.plan': 'Plan',
  'subscription.planSelection': 'Wybrany plan',
  'subscription.planWord': 'Plan',
  'subscription.plusVAT': '+ VAT',
  'subscription.popular': 'Popularny',
  'subscription.prioritySupport': 'Priorytetowe wsparcie',
  'subscription.pro': 'Pro',
  'subscription.processing': 'Przetwarzanie...',
  'subscription.professional': 'Professional',
  'subscription.professionalDesc': 'Dla rozwijających się firm',
  'subscription.purchasePlanTitle': 'Zakup planu {name}',
  'subscription.receiptsLabel': 'Paragony',
  'subscription.redirectingToPayment': 'Przekierowywanie na stronę płatności...',
  'subscription.referralDesc': 'Gdy zaproszony znajomy zarejestruje się i zostanie członkiem, otrzymasz 1 dodatkowy miesiąc! Samo wysłanie zaproszenia nie wystarczy.',
  'subscription.referralShare': 'Udostępnij link z zaproszeniem',
  'subscription.referralTitle': 'Poleć znajomym',
  'subscription.region.europe': '🇪🇺 Europa',
  'subscription.region.other': '🌎 Inne',
  'subscription.region.turkey': '🇹🇷 Turcja',
  'subscription.removeCoupon': 'Usuń',
  'subscription.renew': 'Odnów',
  'subscription.renewNow': 'Odnów teraz',
  'subscription.renewsInDays': 'Twoja bieżąca subskrypcja zostanie odnowiona za {days} dni',
  'subscription.sandboxMode': '🧪 SANDBOX (tryb testowy)',
  'subscription.sandboxOnly': '📝 UWAGA: Te karty działają tylko w środowisku Sandbox!',
  'subscription.sandboxTestCards': '🎴 KARTY TESTOWE (SANDBOX)',
  'subscription.save': 'Oszczędzasz {percent}%',
  'subscription.saveInfoBtn': '💾 Zapisz dane',
  'subscription.saveInfoHint': 'Zostaną uzupełnione automatycznie przy następnej płatności',
  'subscription.savedBillingInfo': '📄 Zapisane dane do faktury',
  'subscription.selectBtn': 'Wybierz',
  'subscription.selectPackage': 'Wybierz pakiet',
  'subscription.selectPlan': 'Wybierz plan',
  'subscription.startDate': 'Data rozpoczęcia',
  'subscription.starter': 'Starter',
  'subscription.starterDesc': 'Idealny dla małych firm',
  'subscription.status': 'Status',
  'subscription.subCancelledBadge': '⚠️ Subskrypcja anulowana',
  'subscription.subInfoTitle': '📋 Informacje o subskrypcji',
  'subscription.subIsMonthly': '✅ To jest subskrypcja miesięczna.',
  'subscription.subIsYearly': '✅ To jest subskrypcja roczna.',
  'subscription.subtitle': 'Zarządzaj planem i ustawieniami rozliczeń',
  'subscription.subtotal': 'Suma częściowa',
  'subscription.successfulPaymentCards': '✅ KARTY TESTOWE – PŁATNOŚĆ UDANA:',
  'subscription.supportTicket': 'Czas odpowiedzi na zgłoszenie: {hours} godz.',
  'subscription.supportTicketBusiness': 'Czas odpowiedzi na zgłoszenie: {hours} godz. (w godzinach pracy)',
  'subscription.supportTimeLabel': 'Czas odpowiedzi na zgłoszenie',
  'subscription.switchPlan': '💳 Przejdź na pakiet',
  'subscription.switchPlanIntl': '🏓 Przejdź na pakiet',
  'subscription.tax': 'VAT ({rate}%)',
  'subscription.taxNumber': 'Numer NIP',
  'subscription.taxNumberPlaceholder': 'Wpisz numer NIP',
  'subscription.taxOffice': 'Urząd skarbowy',
  'subscription.title': 'Subskrypcja',
  'subscription.total': 'Razem',
  'subscription.totalAmountLabel': 'Kwota łączna',
  'subscription.trial': 'Okres próbny',
  'subscription.trial15d': '15-dniowy okres próbny',
  'subscription.trialDaysLeft': 'dni okresu próbnego pozostało',
  'subscription.trialEnd': 'Okres próbny kończy się',
  'subscription.unlimitedUsers': 'Nieograniczona liczba użytkowników',
  'subscription.upgrade': 'Ulepsz plan',
  'subscription.upgradeBtn': 'Ulepsz',
  'subscription.upgradePlan': 'Ulepsz',
  'subscription.upgradeToEnterprise': 'Przejdź na Enterprise',
  'subscription.usageTitle': 'Wykorzystanie i limity w tym miesiącu',
  'subscription.usersLabel': 'Użytkownicy',
  'subscription.vatNote': '+ VAT (20%)',
  'subscription.warning': 'Ostrzeżenie dotyczące subskrypcji',
  'subscription.whatsappCredits': '🎁 {count} kredytów WhatsApp w prezencie',
  'subscription.whatsappCreditsAmount': '{count} kredytów',
  'subscription.whatsappCreditsPackages': 'Pakiety kredytów',
  'subscription.whatsappCreditsTitle': 'Kredyty WhatsApp',
  'subscription.whatsappCurrentBalance': 'Bieżące saldo',
  'subscription.whatsappIntegration': 'Integracja z WhatsApp',
  'subscription.whatsappPurchaseCredits': 'Kup kredyty',
  'subscription.year': 'rok',
  'subscription.yearly': 'Rocznie',
  'subscription.yearlyFreeBtn': '🎉 Rocznie (2 miesiące gratis!)',
  'subscription.yearlyFreeNote': '🎉 Przy płatności rocznej 2 miesiące gratis!',
  'subscription.yearlySavings': '💡 Oszczędź 17% przy płatności rocznej',
  'tailoring.addCustomHint': 'Użyj przycisku +, aby dodać własną usługę',
  'tailoring.astarDegisimi': 'Wymiana podszewki',
  'tailoring.belAyarı': 'Dopasowanie w pasie',
  'tailoring.cepDikimi': 'Szycie kieszeni',
  'tailoring.dugmeDikme': 'Przyszycie guzika',
  'tailoring.fermuarDegisimi': 'Wymiana zamka',
  'tailoring.kolBoyu': 'Długość rękawa',
  'tailoring.omuzAyarı': 'Dopasowanie ramion',
  'tailoring.pacaBoyu': 'Dopasowanie pachy',
  'tailoring.savePricesHint': 'Kliknij Zapisz, aby zapisać ceny',
  'tailoring.sokukDikimi': 'Naprawa szwu',
  'tailoring.yama': 'Łata',
  'tickets.admin': 'Administrator',
  'tickets.closed': 'Zamknięte',
  'tickets.closedMessage': 'To zgłoszenie zostało zamknięte.',
  'tickets.conversation': 'Rozmowa',
  'tickets.createError': 'Nie udało się utworzyć zgłoszenia',
  'tickets.created': 'Zgłoszenie zostało utworzone',
  'tickets.description': 'Opis',
  'tickets.descriptionPlaceholder': 'Opisz szczegółowo swój problem...',
  'tickets.fillAllFields': 'Wypełnij wszystkie pola',
  'tickets.loadError': 'Nie udało się wczytać zgłoszeń',
  'tickets.messages': 'Wiadomości',
  'tickets.newTicket': 'Nowe zgłoszenie',
  'tickets.noTickets': 'Nie znaleziono zgłoszeń',
  'tickets.noTicketsDesc': 'Nie masz jeszcze żadnych zgłoszeń',
  'tickets.rateDescription': 'Oceń jakość obsługi',
  'tickets.rateExperience': 'Oceń swoje doświadczenie',
  'tickets.rateSupport': 'Ocena obsługi',
  'tickets.rating.bad': 'Źle',
  'tickets.rating.excellent': 'Doskonale',
  'tickets.rating.good': 'Dobrze',
  'tickets.rating.okay': 'Przeciętnie',
  'tickets.rating.veryBad': 'Bardzo źle',
  'tickets.ratingError': 'Nie udało się zapisać oceny',
  'tickets.ratingSubmitted': 'Twoja ocena została zapisana, dziękujemy!',
  'tickets.selectRating': 'Wybierz ocenę',
  'tickets.sendError': 'Nie udało się wysłać wiadomości',
  'tickets.status.closed': 'Zamknięte',
  'tickets.status.investigating': 'W trakcie analizy',
  'tickets.status.open': 'Otwarte',
  'tickets.status.waitingCustomer': 'Oczekuje na klienta',
  'tickets.subject': 'Temat',
  'tickets.subjectPlaceholder': 'Temat zgłoszenia...',
  'tickets.title': 'Zgłoszenia do pomocy technicznej',
  'tickets.translationError': 'Błąd tłumaczenia',
  'tickets.typeMessage': 'Wpisz wiadomość...',
  'tickets.yourName': 'Twoje imię',
  'tickets.yourNamePlaceholder': 'Wpisz swoje imię...',
  'tickets.yourRating': 'Twoja ocena',
  'toast.addProduct': 'Dodaj produkt',
  'toast.addressRequiredForDelivery': 'Do dostawy/odbioru pod adresem wymagany jest adres klienta. Uzupełnij dane adresowe.',
  'toast.amountExceedsRemaining': 'Kwota przekracza pozostałe saldo',
  'toast.cardPaymentError': 'Błąd płatności kartą',
  'toast.cardPaymentFailed': 'Płatność nie powiodła się. Spróbuj ponownie.',
  'toast.cardPaymentSuccess': 'Płatność kartą zakończona pomyślnie',
  'toast.cardPaymentSuccessMsg': 'Płatność kartą zakończona pomyślnie!',
  'toast.carpetAddedToCart': 'Dywan dodany do koszyka',
  'toast.carpetsAddedToCart': 'Dywany dodane do koszyka',
  'toast.connectionError': 'Nie udało się zapisać połączenia',
  'toast.connectionStatusError': 'Nie udało się wczytać stanu połączenia',
  'toast.customerAdded': 'Klient dodany',
  'toast.customerDebt': 'Zadłużenie klienta: {amount}',
  'toast.customerError': 'Nie udało się dodać klienta',
  'toast.customerExistingSelected': 'Wybrano istniejącego klienta',
  'toast.customerOpenOrders': 'Klient ma otwarte zamówienia: {count}',
  'toast.customerPhoneNotFound': 'Nie znaleziono telefonu klienta',
  'toast.customerSaveError': 'Nie udało się zapisać klienta',
  'toast.customerSaved': 'Klient zapisany',
  'toast.customerUpdateError': 'Nie udało się zaktualizować klienta',
  'toast.customerUpdated': 'Klient zaktualizowany',
  'toast.deliveryDatePastError': 'Data wydania nie może być wcześniejsza niż dzisiaj',
  'toast.demoCustomersKept': 'Zachowano {n} przykładowych klientów, ponieważ mają utworzone przez Ciebie paragony; usunięto tylko ich przykładowe paragony.',
  'toast.demoDataDeleteError': 'Nie udało się usunąć danych demonstracyjnych',
  'toast.demoDataDeleted': 'Dane demonstracyjne usunięte',
  'toast.disconnectError': 'Nie udało się rozłączyć',
  'toast.editCancelled': 'Edycja anulowana',
  'toast.enterValidAmount': 'Wprowadź prawidłową kwotę',
  'toast.enterValidArea': 'Wprowadź prawidłową powierzchnię',
  'toast.enterValidValue': 'Wprowadź prawidłową wartość',
  'toast.fillAllCardInfo': 'Uzupełnij wszystkie dane karty',
  'toast.invalidCardNumber': 'Nieprawidłowy numer karty',
  'toast.invalidCvc': 'Nieprawidłowy kod CVC',
  'toast.invalidMonth': 'Nieprawidłowy miesiąc (musi być 1-12)',
  'toast.invalidYear': 'Nieprawidłowy rok',
  'toast.logoRemoved': 'Logo usunięte. Nie zapomnij zapisać!',
  'toast.logoTooLarge': 'Plik logo jest za duży',
  'toast.logoTypeError': 'Można przesyłać tylko pliki graficzne',
  'toast.logoUploadError': 'Nie udało się przesłać logo',
  'toast.logoUploaded': 'Logo przesłane. Nie zapomnij zapisać!',
  'toast.noDemoData': 'Nie znaleziono przykładowych klientów do usunięcia.',
  'toast.noEditPermission': 'Nie masz uprawnień do edycji',
  'toast.orderCreated': 'Zamówienie utworzone',
  'toast.orderDetailsLoadError': 'Nie udało się wczytać szczegółów zamówienia',
  'toast.orderError': 'Nie udało się utworzyć zamówienia',
  'toast.orderLoadError': 'Nie udało się wczytać zamówienia',
  'toast.orderNotFound': 'Nie znaleziono zamówienia',
  'toast.orderSaveError': 'Nie udało się zapisać kolejności',
  'toast.orderSaved': 'Kolejność zapisana',
  'toast.orderSetToReady': 'Zamówienie oznaczone jako gotowe',
  'toast.orderStatusUpdateError': 'Nie udało się zaktualizować statusu zamówienia',
  'toast.orderStatusUpdated': 'Status zamówienia zaktualizowany',
  'toast.orderUpdateError': 'Nie udało się zaktualizować zamówienia',
  'toast.paymentFailedTryAgain': 'Płatność nie powiodła się, spróbuj ponownie',
  'toast.paymentStatusCheckError': 'Nie udało się sprawdzić statusu płatności. Sprawdź swoje konto.',
  'toast.paymentStatusCheckErrorShort': 'Nie udało się sprawdzić statusu płatności.',
  'toast.pinChangeError': 'Nie udało się zmienić kodu PIN',
  'toast.pinChanged': 'Kod PIN zmieniony',
  'toast.priceUpdated': 'Cena zaktualizowana',
  'toast.productAdded': 'Produkt dodany',
  'toast.productAddedSimple': 'Produkt dodany',
  'toast.productAddedToCart': 'Produkt dodany do koszyka',
  'toast.productDetailsUpdated': 'Szczegóły produktu zaktualizowane',
  'toast.productError': 'Nie udało się dodać produktu',
  'toast.productsLoadError': 'Nie udało się wczytać produktów',
  'toast.qrError': 'Nie udało się wygenerować kodu QR',
  'toast.qrGenerated': 'Kod QR wygenerowany. Zeskanuj go w aplikacji WhatsApp Business.',
  'toast.searchError': 'Błąd wyszukiwania',
  'toast.selectAtLeastOneOperation': 'Wybierz co najmniej jedną czynność',
  'toast.selectAtLeastOneService': 'Wybierz co najmniej jedną usługę',
  'toast.selectCustomer': 'Wybierz klienta',
  'toast.selectPaymentMethodFirst': 'Najpierw wybierz metodę płatności',
  'toast.settingsError': 'Nie udało się zapisać ustawień',
  'toast.settingsLoadError': 'Nie udało się wczytać ustawień',
  'toast.settingsSaved': 'Ustawienia zapisane',
  'toast.statsError': 'Nie udało się wczytać statystyk',
  'toast.statusUpdateError': 'Nie udało się zaktualizować statusu',
  'toast.tailorAddedToCart': 'Usługa krawiecka dodana do koszyka',
  'toast.uploadingLogo': 'Przesyłanie logo...',
  'toast.userAddError': 'Nie udało się dodać użytkownika',
  'toast.userAdded': 'Użytkownik dodany',
  'toast.userDeleteError': 'Nie udało się usunąć użytkownika',
  'toast.userDeleted': 'Użytkownik został usunięty',
  'toast.userUpdateError': 'Nie udało się zaktualizować użytkownika',
  'toast.userUpdated': 'Użytkownik zaktualizowany',
  'toast.usersLoadError': 'Nie udało się wczytać użytkowników',
  'toast.whatsappConnected': 'WhatsApp Business połączony pomyślnie!',
  'toast.whatsappDisconnected': 'WhatsApp Business rozłączony',
  'toast.whatsappFailed': 'Nie udało się wysłać wiadomości WhatsApp',
  'toast.whatsappSent': 'Wiadomość WhatsApp wysłana',
  'update': 'Aktualizuj',
  'users.deleteError': 'Nie udało się usunąć użytkownika',
  'users.loadError': 'Nie udało się wczytać użytkowników',
  'users.userDeleteError': 'Nie udało się usunąć użytkownika',
  'users.userDeleted': 'Użytkownik został usunięty',
  'whatsapp.buyCredits': 'Kup kredyty',
  'whatsapp.connect': 'Połącz WhatsApp',
  'whatsapp.connectWithQR': 'Połącz kodem QR',
  'whatsapp.connected': 'Połączono',
  'whatsapp.connectionStatus': 'Stan połączenia',
  'whatsapp.creditPackages': 'Pakiety kredytów',
  'whatsapp.credits': 'Kredyty',
  'whatsapp.creditsRemaining': 'pozostałych kredytów',
  'whatsapp.deliveryReminder': '{customerName}, od {daysAgo} dni nie odebrano Twojego zamówienia nr {orderNumber}. Prosimy o jak najszybszy odbiór.',
  'whatsapp.disconnect': 'Rozłącz',
  'whatsapp.disconnected': 'Rozłączono',
  'whatsapp.generateQR': 'Wygeneruj kod QR',
  'whatsapp.importantInfo': 'Ważne informacje',
  'whatsapp.info1': '1. Zeskanuj kod QR w aplikacji WhatsApp na telefonie',
  'whatsapp.info2': '2. Po nawiązaniu połączenia możesz wysyłać wiadomości automatyczne',
  'whatsapp.info3': '3. Aby zerwać połączenie, wyloguj urządzenie w ustawieniach WhatsApp',
  'whatsapp.info4': '4. Kod QR odświeża się automatycznie co 60 sekund',
  'whatsapp.messageHistory': 'Historia wiadomości',
  'whatsapp.messages': 'wiadomości',
  'whatsapp.noCredits': 'Brak pozostałych kredytów',
  'whatsapp.notConnectedMessage': 'Twoje konto WhatsApp nie jest jeszcze połączone',
  'whatsapp.orderDelivered': 'Zamówienie wydane',
  'whatsapp.orderReady': 'Zamówienie gotowe',
  'whatsapp.preview': 'Podgląd',
  'whatsapp.receiptCreated': 'Paragon utworzony',
  'whatsapp.receiptMessage': 'Szanowny(-a) {customerName}, Twoje zamówienie nr {orderNumber} jest gotowe i czeka na odbiór.',
  'whatsapp.save': 'Zapisz szablon',
  'whatsapp.saved': 'Szablon zapisany',
  'whatsapp.scanQR': 'Zeskanuj kod QR',
  'whatsapp.sendTest': 'Wyślij wiadomość testową',
  'whatsapp.status': 'Status',
  'whatsapp.subtitle': 'Zarządzaj połączeniem z WhatsApp Business API',
  'whatsapp.template': 'Szablon',
  'whatsapp.templates': 'Szablony wiadomości',
  'whatsapp.testFailed': 'Nie udało się wysłać wiadomości testowej',
  'whatsapp.testSent': 'Wiadomość testowa wysłana',
  'whatsapp.thankYou': 'Dziękujemy!',
  'whatsapp.title': 'WhatsApp',
  'zReport.account': 'Konto klienta (Caripay)',
  'zReport.accountCollections': 'Wpłaty na konta klientów',
  'zReport.bankTransfer': 'Przelew bankowy',
  'zReport.branchCollectionsNote': 'Wpłaty własne + z innych oddziałów',
  'zReport.byEmployee': 'Według pracownika',
  'zReport.byProduct': 'Według produktu',
  'zReport.byService': 'Według usługi',
  'zReport.cancelledOrders': 'Anulowane zamówienia',
  'zReport.cancelledReceipts': 'Anulowane paragony',
  'zReport.cardPayments': 'Płatności kartą',
  'zReport.cariCollection': 'Wpłaty na konto klienta',
  'zReport.cash': 'Gotówka',
  'zReport.cashBoxStartNote': 'Stan początkowy kasy',
  'zReport.cashCalculation': '(Gotówka początkowa + Dzisiejsza gotówka - Wydatki)',
  'zReport.cashIn': 'Wpłaty do kasy',
  'zReport.cashOut': 'Wypłaty z kasy',
  'zReport.cashPayments': 'Płatności gotówką',
  'zReport.cashRegister': 'Kasa',
  'zReport.cashToDeliver': 'Gotówka do przekazania',
  'zReport.closingBalance': 'Saldo końcowe',
  'zReport.collectedItems': 'Opłacone pozycje',
  'zReport.collectionDetails': 'Szczegóły wpłat',
  'zReport.creditCard': 'Karta kredytowa',
  'zReport.creditPayments': 'Płatności na kredyt',
  'zReport.custom': 'Niestandardowy',
  'zReport.daily': 'Dzienny',
  'zReport.dailyCashIncome': 'Dzienny przychód gotówkowy',
  'zReport.dailyExpensesNote': 'Dzisiejsze wydatki',
  'zReport.dateRange': 'Zakres dat',
  'zReport.deliveryCard': 'Karta przy wydaniu',
  'zReport.deliveryCash': 'Gotówka przy wydaniu',
  'zReport.discountNotReflected': 'Kwoty są obliczane na podstawie cen netto po uwzględnieniu rabatów.',
  'zReport.endDate': 'Data końcowa',
  'zReport.excelDownloaded': 'Plik Excel pobrany',
  'zReport.excelError': 'Błąd pobierania pliku Excel',
  'zReport.expenses': 'Wydatki',
  'zReport.free': 'Bezpłatnie',
  'zReport.freeOrders': 'Bezpłatne zamówienia',
  'zReport.generateReport': 'Generuj raport',
  'zReport.incoming': 'Przychody',
  'zReport.infoNote': 'Wyłącznie informacyjnie',
  'zReport.loadError': 'Nie udało się wczytać raportu Z',
  'zReport.loading': 'Wczytywanie...',
  'zReport.mealCard': 'Karta posiłkowa',
  'zReport.monthly': 'Miesięczny',
  'zReport.newCustomers': 'Nowi klienci',
  'zReport.noCancelled': 'Brak anulowanych paragonów',
  'zReport.noData': 'Brak danych dla tego okresu',
  'zReport.noExpenses': 'Brak wydatków',
  'zReport.onDelivery': 'Płatność przy wydaniu',
  'zReport.openingBalance': 'Saldo początkowe',
  'zReport.orderCollections': 'Wpłaty za zamówienia',
  'zReport.orderPaidAtDelivery': 'Zamówienia opłacone przy wydaniu',
  'zReport.orderPaidAtRegister': 'Zamówienia opłacone przy przyjęciu',
  'zReport.outgoing': 'Rozchody',
  'zReport.paidAtDelivery': 'Opłacone przy wydaniu',
  'zReport.paidAtRegister': 'Opłacone przy przyjęciu',
  'zReport.paymentDetails': 'Szczegóły wpłat',
  'zReport.paymentMethods': 'Metody płatności',
  'zReport.period': 'Okres',
  'zReport.printReport': 'Drukuj raport',
  'zReport.reason': 'Powód',
  'zReport.registrationAndDelivery': 'Przyjęcie + wydanie',
  'zReport.returningCustomers': 'Powracający klienci',
  'zReport.selectDate': 'Wybierz datę',
  'zReport.serviceBreakdown': 'Podział według usług',
  'zReport.singleDay': 'Jeden dzień',
  'zReport.startDate': 'Data początkowa',
  'zReport.startingCash': 'Gotówka początkowa',
  'zReport.title': 'Raport Z',
  'zReport.todayCashNote': 'Gotówka otrzymana dzisiaj',
  'zReport.todayRegistrations': 'Dzisiejsze przyjęcia',
  'zReport.totalCancelled': 'Anulowane paragony: {count}',
  'zReport.totalCollected': 'Łącznie zebrano',
  'zReport.totalCollection': 'Łączne wpłaty',
  'zReport.totalExpenses': 'Łączne wydatki',
  'zReport.totalItems': 'Łączna liczba pozycji',
  'zReport.totalOrders': 'Łącznie zamówień',
  'zReport.totalRefunds': 'Łączne zwroty',
  'zReport.totalRegistered': 'Łącznie przyjęto',
  'zReport.totalRevenue': 'Przychód łączny',
  'zReport.totalSales': 'Sprzedaż łączna',
  'zReport.transferPayments': 'Płatności przelewem',
  'zReport.weekly': 'Tygodniowy',
  'zreport.card': 'Karta',
  'zreport.cash': 'Gotówka',
  'zreport.date': 'Data',
  'zreport.orders': 'Zamówienia',
  'zreport.print': 'Drukuj',
  'zreport.title': 'Raport Z',
  'zreport.total': 'Razem',
  'toast.logoSizeError': 'Plik logo musi być mniejszy niż 500 KB',
  'zReport.todayOrders': 'Dzisiejsze zamówienia',
};
